import angular from 'angular';
import { CommonsConstants } from 'ib-web-commons/constants';
import dayjs from 'dayjs';
import { formatTotalPriceToString } from '../cmpnts/ib-pmt-dcc/ib-pmt-dcc.utils';
import { Subscription } from 'rxjs';
declare global {
    class AdyenCheckout{
        constructor (obj);
    }
}
@Controller('ib-pmt-module',
    ['$rootScope',
        '$scope',
        '$filter',
        'localStorageService',
        'PmtModalService',
        'PmtTransformer',
        'PmtService',
        '$location',
        'PmtConstants',
        '$sce',
        '$document',
        '$compile',
        '$timeout',
        '$window',
        'PmtUtilsService',
        'CurrencyService',
        'DatalayerUtilsService',
        'PmtDatalayerConstants',
        'DatalayerEcommerceUtilsService',
        'PmtMethodsTransformer',
        'DataLayerService',
        'PmtUtilsTransformers',
        'MonetateUtilsService',
        'CommonsAncillariesService',
        'PmtBreakDownUtilsService',
        'PmtDatalayerUtilsService',
        'NewMainHeaderFacade',
        'PmtAssFassAncillariesService',
        'pmtConditionsGiftCardsService',
        'MonetateConstants',
        'CommonsUtilService',
        'CommonsUserUtilsService',
        'GetDestinationsService',
        'CommonsKeepAliveUtilsService',
        'DigitalDataService',
        'QuantumService',
        'DatalayerConstants',
        'DatalayerGeneralConstants',
        'ibPmtNemuruService',
        'ibPmtMercadoPagoService',
        'IbUiAviosSummaryService',
        'PMTCheckPartnerDiscountsService',
        'DccService'], [])
class PmtPageController {
    public showQuotasInfoFlowAppDisallowed;
    public showGeneralSummary;
    public showCkiSummary;
    public showMmbAncillariesSummary;
    public appliedCCFee;
    public aviosToEarn;
    public elitePointsToEarn;
    public numberFreeUpgrade;
    public submittedTabs;
    public totalAviosAmount;
    public nemuruAvailableObserver;
    public mercadoPagoAvailableObserver;
    public isIbZero;
    public isSoftUser;
    public showOnHoldNotice;
    public iframeReadyCount;
    public allowedCashAndAviosWithVoucher;
    public loadingOnlineBankingForm;
    public loadingIframeForm;
    public flowApp;
    public isShuttleFlow;
    public modelSummaryMmbAnc;
    public deepLinkData;
    public generisONBFlowateIframeForm;
    public ibPayTrace;
    public model;
    public numberCallEvent;
    public LOGIN_ONB;
    public isChecked;
    public isONBFlow;
    public showNoDiscountOBPrice;
    public originalOBPrice;
    public noDiscountOBPrice;
    public showOBPoints;
    public oBPoints;
    public dataRequest;
    public quotaIsLoading;
    public quotaIbPayCall;
    public nemuruIsCalled;
    public mercadoPagoIsCalled;
    public paymentsForm;
    public digital_data;
    public asComponent;
    public adyenCheckout;
    public selectedData;
    public modelLightBox;
    public actualStepFlow;
    public showExternalButton;
    private currentDccData: DccModel.CurrentDccData;
    private donationEnabled: boolean;
    private dccDataObersever: Subscription;
    private onHoldFreeSelected: boolean = false;
    constructor (
        private $rootScope,
        private $scope,
        private $filter,
        private localStorageService,
        private PmtModalService,
        private PmtTransformer,
        private PmtService,
        private $location,
        private PmtConstants,
        private $sce,
        private $document,
        private $compile,
        private $timeout,
        private $window,
        private PmtUtilsService,
        private CurrencyService,
        private DatalayerUtilsService,
        private PmtDatalayerConstants,
        private DatalayerEcommerceUtilsService,
        private PmtMethodsTransformer,
        private DataLayerService,
        private PmtUtilsTransformers,
        private MonetateUtilsService,
        private CommonsAncillariesService,
        private PmtBreakDownUtilsService,
        private PmtDatalayerUtilsService,
        private NewMainHeaderFacade,
        private PmtAssFassAncillariesService,
        private pmtConditionsGiftCardsService,
        private MonetateConstants,
        private CommonsUtilService,
        private CommonsUserUtilsService,
        private GetDestinationsService,
        private CommonsKeepAliveUtilsService,
        private DigitalDataService,
        private QuantumService,
        private DatalayerConstants,
        private DatalayerGeneralConstants,
        private ibPmtNemuruService,
        private ibPmtMercadoPagoService,
        private IbUiAviosSummaryService,
        private PMTCheckPartnerDiscountsService,
        private DccService

    ) {}

    activate = () => {
        let submitedPaymentEvent,
            generate3DSFORMEvent,
            generate3DSIFRAMEvent,
            externalButtonFormEvent,
            paymentOnHoldOptionEvent,
            noPaymentGoConfirmation,
            generate3ds2AdyenComponentEvent,
            closeOnholdLightBoxEvent,
            generate3ds2OneSiteIframeEvent,
            generateAfopRedirectEvent,
            generateAfopNemuru,
            generateAfopMercadoPago,
            voucherFlightAviosInfoEvent,
            voucherFlightAviosInfoEventError;

        this.showQuotasInfoFlowAppDisallowed = [CommonsConstants.APP_TYPES.GIFTCARDS, CommonsConstants.APP_TYPES.ONHOLD, CommonsConstants.APP_TYPES.MANAGEMYBOOKING_ANCILLARIES];
        this.showGeneralSummary = false;
        this.showCkiSummary = false;
        this.showMmbAncillariesSummary = false;
        this.appliedCCFee = false;
        this.aviosToEarn = null;
        this.elitePointsToEarn = null;
        this.numberFreeUpgrade = this.localStorageService.get('numberFreeUpgrade');
        this.submittedTabs = {};
        this.totalAviosAmount = this.localStorageService.get('totalAviosAmount');

        this.nemuruAvailableObserver;

        submitedPaymentEvent = this.$rootScope.$on('submitedPaymentPCCEvent', this.submitPayment);
        this.$scope.$on('$destroy', submitedPaymentEvent);
        generate3DSFORMEvent = this.$rootScope.$on('generate3DSRedirectForm', this.externalPayForm);
        this.$scope.$on('$destroy', generate3DSFORMEvent);
        generateAfopRedirectEvent = this.$rootScope.$on('generateAfopRedirect', this.externalPayForm);
        this.$scope.$on('$destroy', generateAfopRedirectEvent);
        generateAfopNemuru = this.$rootScope.$on('generateAfopNemuru', this.callWithKeepSessionAlive(this.loadNemuruComponent));
        this.$scope.$on('$destroy', generateAfopNemuru);
        generateAfopMercadoPago = this.$rootScope.$on('generateAfopMercadoPago', this.callWithKeepSessionAlive(this.loadMercadoPagoComponent));
        this.$scope.$on('$destroy', generateAfopMercadoPago);
        generate3ds2AdyenComponentEvent = this.$rootScope.$on('generate3ds2AdyenComponent', this.callWithKeepSessionAlive(this.adyenComponent));
        this.$scope.$on('$destroy', generate3ds2AdyenComponentEvent);
        generate3ds2OneSiteIframeEvent = this.$rootScope.$on('generate3ds2OneSiteIframe', this.oneSiteIframe);
        this.$scope.$on('$destroy', generate3ds2OneSiteIframeEvent);
        generate3DSIFRAMEvent = this.$rootScope.$on('generate3DSModalForm', this.generateIframeForm);
        this.$scope.$on('$destroy', generate3DSIFRAMEvent);
        externalButtonFormEvent = this.$rootScope.$on('generateExtenalButtonForm', this.generateExternalButtonForm);
        this.$scope.$on('$destroy', externalButtonFormEvent);
        paymentOnHoldOptionEvent = this.$rootScope.$on('paymentOnHoldOption', this.submitPayment);
        this.$scope.$on('$destroy', paymentOnHoldOptionEvent);
        noPaymentGoConfirmation = this.$rootScope.$on('noPaymentGoConfirmation', this.noPayment);
        this.$scope.$on('$destroy', noPaymentGoConfirmation);
        voucherFlightAviosInfoEvent = this.$rootScope.$on('voucherFlightAviosInfo', this.updateAviosCalculated);
        this.$scope.$on('$destroy', voucherFlightAviosInfoEvent);
        voucherFlightAviosInfoEventError = this.$rootScope.$on('voucherFlightAviosInfoError', this.aviosCalculatedError);
        this.$scope.$on('$destroy', voucherFlightAviosInfoEventError);

        this.$scope.$on('changeSelectedCreditCard', this.updateSelectedCardFields);
        this.$scope.$on('changeUserSelectedCreditCard', this.updateUserSelectedCreditCard);
        this.$scope.$on('getSummaryInfoQuota', this.getSummaryInfoQuota);
        this.$scope.$on('getIberiaPayQuotaInfo', this.getIberiaPayQuotaInfo);
        this.$scope.$on('openModalInfoQuota', this.openModalInfoQuota);
        this.$scope.$on('showGeneralModalInfoQuota', this.openGeneralModalInfoQuotas);
        this.$scope.$on('changeIssuerCountryEvent', this.changeIssuerCountry);
        this.$scope.$on('changeSelectedTab', this.changeSelectedTab);
        this.$scope.$on('updatePaymenthMethodsInfo', this.updatePaymenthMethodsInfo);
        this.$scope.$on('paypalUndefinedEvent', this.paypalUndefined);
        this.$scope.$on('payWithPaypal', this.confirmationPaypal);
        this.$scope.$on('submitFormEvent', this.callWithKeepSessionAlive(this.submitForm));
        this.$scope.$on('submitedPaymentEvent', this.submitPayment);
        this.$scope.$on('openSummaryModalTaxesEvent', this.openModalLinks);
        this.$scope.$on('openSummaryModalLinksEvent', this.openModalLinks);
        this.$scope.$on('openModalCo2InfoEvent', this.openModalLinks);
        this.$scope.$on('paypalPaymentSuccessEvent', this.goToConfirmationPage);
        this.$scope.$on('removeAviosDisscounts', this.removeAviosDisscounts);
        this.$scope.$on('selectOnHoldOptionEvent', this.changeSelectedHoldOption);
        this.$scope.$on('disscountAviosSelected', this.disabledQuotasOption);
        this.$scope.$on('basketUpdate', this.checkBasket);
        this.$scope.$on('basketUpdateCommonHeader', this.checkBasketCommonHeader);
        this.$scope.$on('checkDonation', this.checkDonation);
        this.$scope.$on('getSummaryInfoQuotaDeferedMonth', this.getSummaryInfoQuotaDeferedMonth);
        this.$scope.$on('updateDisccountsTotal', this.updateDisccountsTotal);
        this.$scope.$on('updateCalcAvios', this.updateCalcAvios);
        this.$scope.$on('updateSubmittedTabs', this.updateSubmittedTabs);

        this.DccService.setDccData();
        this.dccDataObersever = this.DccService.dccDataObservable.subscribe((value: DccModel.DccResponse) => {

            this.currentDccData = value? {
                ...value,
                formattedBasePrice: { totalPrice: this.model.paymentInfo.price.formattedTotalPrice, currencyCode: value.basePrice.currency.code},
                formattedSourceTimestamp: dayjs(value.sourceTimestamp).format(this.$rootScope.appMarket === 'US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'),
                totalPrice: formatTotalPriceToString(value.DCCPrice.value, {
                    decimalSeparator: value.basePrice.currency.decimalSeparator,
                    numberDecimals: Number(value.DCCPrice.currencyCode.substring(3)),
                    groupingSeparator: value.basePrice.currency.groupingSeparator
                }),
                currencyCode: value.DCCPrice.currencyCode.replace(/\d/g, ''),
                selectedValue: value.creditCardType==='CA'? this.PmtConstants.PAYMENTS_DCC.DCC_ENABLED : undefined} : undefined;

        });

        this.$document.on('success', this.iberiaPayTokenizeSucces);
        this.$document.on('ready', this.iberiaPayIframeReady);
        this.$document.on('error', this.iberiaPayErrorsControll);
        this.$scope.$on('$destroy', () => {
            this.$document.off('success');
            this.$document.off('ready');
            this.$document.off('error');
            if (this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE || this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED) {
                this.PmtDatalayerUtilsService.resetDatalayer();
            }
        });
        this.$document.off('mouseleave');
        this.$document.on('mouseleave', this.openOnholdLightBox);
        closeOnholdLightBoxEvent = this.$rootScope.$on('closeOnholdLightBox', this.closeOnholdLightBox);
        this.$scope.$on('$destroy', closeOnholdLightBoxEvent);
        var redirectionInfo = this.localStorageService.get('redirectionPaymentCallback'), ancillariesTotalUpdate,
            dataIssueError = this.PmtUtilsService.getOrderId() === this.localStorageService.get('lastRequestedOrderId') ? this.localStorageService.get('errorIssueService') || null : null,
            donationData = this.localStorageService.get('donation'), ancillariesTotalUpdate, i, foundOHMethod, fareData, bookingInfo, pointsData;
        let paDatalayerObject, orderData, paDigitalDataObject, paymentTransition = this.localStorageService.get('paymentProvider');
        const flowId = this.localStorageService.get('flowId');
        const paymentTypeCallback = this.PmtUtilsService.getURLFirstParameterByName(this.PmtConstants.URL_PARAMS_NAMES.PAYMENT_TYPE_CALLBACK);
        this.isIbZero = this.CommonsUserUtilsService.isIbZero();
        this.isSoftUser = this.CommonsUserUtilsService.isSoftUser();
        this.$rootScope.production = this.$rootScope.production || this.$window.env.production;
        this.showOnHoldNotice = false;
        this.iframeReadyCount = 0;
        this.allowedCashAndAviosWithVoucher = this.localStorageService.get('commercialData') && this.localStorageService.get('commercialData').marketFlags && this.localStorageService.get('commercialData').marketFlags.allowedCashAndAviosWithVoucher;
        if(!redirectionInfo && !paymentTypeCallback && this.localStorageService.get('actualStepFlow') !== 'ibpurc') {
            this.localStorageService.set('paymentLocationSearch', this.$window?.location?.search);
        }
        this.localStorageService.get('paySucces') ? this.goToHome() : angular.noop;
        this.localStorageService.set('noShowMessageBockBack', false);
        this.localStorageService.set('nextStepAllowed', true);
        this.localStorageService.set('previousStepFlow', this.localStorageService.get('actualStepFlow'));
        this.localStorageService.set('actualStepFlow', 'ibpurc');
        this.$rootScope.$broadcast('warnUserOnBackPressed', history, this.$window, location, angular, () => {
            return this.PmtModalService.closeAllCurrentModals();
        });
        this.$rootScope.$emit('closeCollapseHeader');
        this.loadingOnlineBankingForm = false;
        this.loadingIframeForm = false;
        this.flowApp = this.localStorageService.get('flowApp');
        this.actualStepFlow = this.localStorageService.get('actualStepFlow');
        this.$timeout(() => {
            this.setTitlePage();
        }, 1600);
        if (!this.$rootScope.isShuttleFlow) {
            this.$rootScope.isShuttleFlow = this.localStorageService.get('isShuttleFlow');
        }
        if (!this.$rootScope.isRedemptionFlow) {
            this.$rootScope.isRedemptionFlow = this.localStorageService.get('isRedemptionFlow');
        }
        if (!this.$rootScope.isPointsOBFlow) {
            this.$rootScope.isPointsOBFlow = this.localStorageService.get('isPointsOBFlow');
        }
        this.isShuttleFlow = this.localStorageService.get('isShuttleFlow');
        this.isONBFlow = false;

        this.NewMainHeaderFacade.updateBasketOthers();
        this.NewMainHeaderFacade.updateBasketDiscounts(this.PmtConstants.DISCOUNT_TYPES.AVIOS);
        if (!(this.$rootScope.isPointsOBFlow || this.$rootScope.isRedemptionFlow) && (this.localStorageService.get('flowApp') === 'BBKI' || this.localStorageService.get('flowApp') === 'BBKIOH') && (this.localStorageService.get('searchFlightType') === 'availabilityFlight' ||this.localStorageService.get('searchFlightType') === 'metasearchFlight')) {
            this.MonetateUtilsService.updateMonetateWithQuadrigam(this.MonetateConstants.MONETATE_INFO.SETPAGETYPE, this.localStorageService.get('multiCitySearch') ? this.localStorageService.get('isHMAD') ? this.PmtConstants.QUADRIGAMS.HMAD_PASSENGERS_INFO : this.PmtConstants.QUADRIGAMS.MULTI_PASSENGERS_INFO : this.selectQuadrigam());
            const selectedSlicesMntt = this.localStorageService.get('selectedTripSegments') ?? this.localStorageService.get('avSelectedOffer').slices?.map(el => [...el.segments]);
            this.MonetateUtilsService.addFlightReviewMonetate(this.localStorageService.get('bookingUrlParams'), this.localStorageService.get('originDestination'), selectedSlicesMntt, this.localStorageService.get('avSelectedOffer'), this.localStorageService.get('fareFamilyConditionsInfo'));
        }
        switch (this.flowApp) {
                case this.PmtConstants.APP_TYPES.CHECKIN:
                    this.NewMainHeaderFacade.updateSteps(this.localStorageService.get('actualStepFlow'));
                    this.NewMainHeaderFacade.showLogin();
                    this.$rootScope.showMainHeader = false;
                    this.$rootScope.showPmtHeader = true;
                    this.showCkiSummary = true;
                    if (this.localStorageService.get('userLogged') && this.localStorageService.get('summaryInfo')) {
                        this.allowedCashAndAviosWithVoucher = true;
                    }
                    break;
                case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ANCILLARIES:
                    this.$rootScope.showMainHeader = false;
                    this.$rootScope.showPmtHeader = false;
                    this.$rootScope.showHeaders = true;
                    this.CommonsAncillariesService.getAncillarieSummary().then((breakdownInfo) => {
                        this.modelSummaryMmbAnc = this.PmtBreakDownUtilsService.transformBreakdownInfo(breakdownInfo);
                    }, angular.noop);
                    this.showMmbAncillariesSummary = true;
                    if (this.localStorageService.get('deepLinkData')) {
                        this.deepLinkData = this.localStorageService.get('deepLinkData');
                    }
                    break;
                case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_BIDS:
                    this.CommonsAncillariesService.getAncillarieSummary().then((breakdownInfo) => {
                        this.modelSummaryMmbAnc = this.PmtBreakDownUtilsService.transformBreakdownUpgradingBid(breakdownInfo);
                    }, angular.noop);
                    this.showMmbAncillariesSummary = true;
                    //this.localStorageService.remove('headerModel');
                    break;
                case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE:
                case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED:
                    this.showGeneralSummary = true;
                    break;
                case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ONHOLD:
                    this.showGeneralSummary = true;
                    this.$rootScope.showMainHeader = false;
                    this.$rootScope.showPmtHeader = false;
                    this.$rootScope.showHeaders = true;
                    this.NewMainHeaderFacade.showLoginMMBOnHold();
                    break;
                case this.PmtConstants.APP_TYPES.SHUTTLE_OPEN:
                case this.PmtConstants.APP_TYPES.SHUTTLE_OPEN_ONB:
                case this.PmtConstants.APP_TYPES.SHUTTLE_REDEMPTION:
                case this.PmtConstants.APP_TYPES.SHUTTLE_REDEMPTION_ONB:
                    this.showGeneralSummary = true;
                    this.$rootScope.showMainHeader = false;
                    this.$rootScope.showHeaders = true;
                    break;
                case this.PmtConstants.APP_TYPES.GIFTCARDS:
                    this.showGeneralSummary = true;
                    this.NewMainHeaderFacade.updateSteps(this.localStorageService.get('actualStepFlow'));
                    this.NewMainHeaderFacade.showLogin();
                    if (this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.GIFTCARDS) {
                        this.pmtConditionsGiftCardsService.getTermnsAndConditions().then((data) => {
                            if (data.data) {
                                this.localStorageService.set('termnsAndConditionGiftCards', data.data.content.text);
                                this.localStorageService.set('gdprGiftCardsInfo', data.data.content);
                            }
                        });
                    }
                    this.$rootScope.showPmtHeader = false;
                    break;
                case this.PmtConstants.APP_TYPES.SUBSCRIPTIONMODELS:
                    this.showGeneralSummary = true;
                    this.NewMainHeaderFacade.updateSteps(this.localStorageService.get('actualStepFlow'));
                    this.NewMainHeaderFacade.showLogin();
                    if (this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.SUBSCRIPTIONMODELS) {
                        this.pmtConditionsGiftCardsService.getTermnsAndConditions().then((data) => {
                            if (data.data) {
                                this.localStorageService.set('termnsAndConditionGiftCards', data.data.content.text);
                                this.localStorageService.set('gdprGiftCardsInfo', data.data.content);
                            }
                        });
                    }
                    this.$rootScope.showPmtHeader = false;
                    break;
                case this.PmtConstants.APP_TYPES.ONHOLD:
                    //Update flow on cart
                    this.DatalayerEcommerceUtilsService.updateAddToCartInfoOnHold();
                    this.showGeneralSummary = true;
                    this.NewMainHeaderFacade.updateSteps(this.localStorageService.get('actualStepFlow'));
                    this.NewMainHeaderFacade.showLogin();
                    this.$rootScope.showMainHeader = false;
                    this.$rootScope.showHeaders = true;
                    orderData = this.localStorageService.get('createOrderData');
                    this.$rootScope.showPmtHeader = false;
                    break;
                default:
                    this.showGeneralSummary = true;
                    this.NewMainHeaderFacade.updateSteps(this.localStorageService.get('actualStepFlow'));
                    this.NewMainHeaderFacade.showLogin();
                    this.$rootScope.showMainHeader = false;
                    this.$rootScope.showHeaders = true;
                    orderData = this.localStorageService.get('createOrderData');
                    this.$rootScope.showPmtHeader = false;
                    break;
        }
        this.$rootScope.pmtPatterns = this.PmtConstants.PATTERNS;
        this.isChecked = this.localStorageService.get('oBDiscountType');
        this.LOGIN_ONB = this.PmtConstants.LOGIN_ONB;
        this.numberCallEvent = 0;
        (this.flowApp === this.PmtConstants.APP_TYPES.BOOKING ||  this.flowApp === this.PmtConstants.APP_TYPES.ONHOLD) && !this.localStorageService.get('currency')? this.localStorageService.set('currency', this.CurrencyService.getCurrencyObject(this.localStorageService.get('createOrderData').contextMetadata.currencies[0])) : angular.noop;
        if (redirectionInfo && (!dataIssueError || (dataIssueError && !dataIssueError.otherPayment))) {
            if (paymentTransition === 'IDEAL') paymentTransition = 'SOFORT';
            this.PmtModalService.showWaitingModal('ib-modal-pmt-cards', 'ib-modals ib-modals--transparent', true, {transition: paymentTransition});
            redirectionInfo.paymentStatus = this.PmtUtilsService.getURLFirstParameterByName(this.PmtConstants.URL_PARAMS_NAMES.PAYMENT_STATUS);
            redirectionInfo.paymentTypeCallback = paymentTypeCallback;
            this.model = redirectionInfo.data;
            this.ibPayTrace = this.localStorageService.get('ibPayTrace');
            this.model.paymentInfo.relatedContent = this.PmtUtilsService.getPaymentRelatedContent(this.model.paymentInfo.relatedContent.original.termsAndConditions, this.model.paymentInfo.relatedContent.original.totalPriceText);
            redirectionInfo.redirectStatus = true;
            this.dataRequest = this.localStorageService.get('pmtModelInfo');
            this.PmtService.getScripts(this.model.paymentInfo, this.model.selectedData.selectedTab).then((response) => {
                this.model.paymentInfo = response.paymentInfo;
                this.model.selectedData.selectedTab = response.selectedTab;
                if (!this.isShuttleFlow && (this.flowApp !== this.PmtConstants.APP_TYPES.GIFTCARDS && this.flowApp !== this.PmtConstants.APP_TYPES.SUBSCRIPTIONMODELS)) {
                    this.updateDatalayerWithQuadrigam(this.localStorageService.get('pmtModelInfo').quadrigams.payments, this.localStorageService.get('confirmationDatalayerInfo'), this.PmtUtilsService.isUserLogged());
                    /* INIT DELETE GA4 MIGRATION */
                    this.DatalayerUtilsService.sendDatalayerEvent(this.PmtDatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
                    /* FINISH DELETE GA4 MIGRATION */
                    this.DigitalDataService.emitViewEvent();
                    //this.DatalayerUtilsService.updateDatalayerEvent(this.PmtDatalayerConstants.DATALAYER_EVENT_TYPES.VIEW, '', '', '');
                }
                if (redirectionInfo.paymentStatus === 'OK' || redirectionInfo.paymentStatus === 'KO' || redirectionInfo.paymentTypeCallback === 'REDIRECT' || redirectionInfo.paymentTypeCallback === 'AFOP_BIZUM' || redirectionInfo.paymentTypeCallback === 'AFOP_SOFORT' || redirectionInfo.paymentTypeCallback === 'AFOP_IDEAL' || redirectionInfo.paymentTypeCallback === 'AFOP_MERCADO_PAGO') {
                    const isRedirectComponent = redirectionInfo.paymentTypeCallback === 'REDIRECT' || redirectionInfo.syncPayment;
                    this.localStorageService.set('redirectionPaymentCallback', redirectionInfo);
                    if (this.localStorageService.get('paySucces') && (this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE || this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED)) {
                        this.$scope.$emit('changeStep', this.PmtConstants.COMPONENT_PAGE.PAYMENTS_PAGE, this.PmtConstants.COMPONENT_PAGE.CONFIRMATION_PAGE);
                    } else if (isRedirectComponent && this.model.paymentInfo.componentInfoAdyen) {
                        this.model.paymentInfo.componentInfoAdyen.data = {
                            md: this.PmtUtilsService.getURLFirstParameterByName(this.PmtConstants.URL_PARAMS_NAMES.PAYMENT_3DS2_CALLBACK_MD) ? this.PmtUtilsService.getURLFirstParameterByName(this.PmtConstants.URL_PARAMS_NAMES.PAYMENT_3DS2_CALLBACK_MD) : this.localStorageService.get('componentInfoAdyen').md,
                            paRes: this.PmtUtilsService.getURLFirstParameterByName(this.PmtConstants.URL_PARAMS_NAMES.PAYMENT_3DS2_CALLBACK_PARES) ? this.PmtUtilsService.getURLFirstParameterByName(this.PmtConstants.URL_PARAMS_NAMES.PAYMENT_3DS2_CALLBACK_PARES) : this.localStorageService.get('componentInfoAdyen').paRes
                        };
                        this.submitPayment(null, '3ds2Adyen');
                    } else if (isRedirectComponent && redirectionInfo.oneSiteSync) {
                        this.submitPayment(null, '3dsOneSiteSync');
                    } else if (isRedirectComponent && redirectionInfo.oneSiteIframe) {
                        this.submitPayment(null, '3ds2OneSite');
                    } else if (redirectionInfo.paymentTypeCallback === 'AFOP_BIZUM' || redirectionInfo.paymentTypeCallback === 'AFOP_SOFORT' || redirectionInfo.paymentTypeCallback === 'AFOP_IDEAL' || redirectionInfo.paymentTypeCallback === 'AFOP_MERCADO_PAGO') {
                        if (this.model.paymentInfo.componentInfoAdyen) {
                            this.model.paymentInfo.componentInfoAdyen.redirectResult = this.PmtUtilsService.getURLFirstParameterByName('redirectResult') ? this.PmtUtilsService.getURLFirstParameterByName('redirectResult') : this.localStorageService.get('redirectResult');
                        }
                        this.submitPayment(null, 'iberiaPayAfop');
                    } else {
                        this.submitPayment(null);
                    }
                    this.localStorageService.set('noShowMessageBockBack', true);
                } else {
                    this.localStorageService.remove('redirectionPaymentCallback');
                    this.reloadPage();
                }
            });
        } else if (dataIssueError && dataIssueError.otherPayment) {
            this.dataRequest = this.PmtTransformer.getPaymentsModel();
            this.ibPayTrace = this.localStorageService.get('ibPayTrace');
            this.model = this.localStorageService.get('modelPaymentData');
            this.model.showOptions.loadingPaymentData = true;
            this.localStorageService.remove('errorIssueService');
            this.localStorageService.remove('selectedPaymentData');
            if (dataIssueError.data.paymentOptions && dataIssueError.data.paymentOptions.paymentMethods.length > 0) {
                for (i = 0; i < dataIssueError.data.paymentOptions.paymentMethods.length; i++) {
                    if (dataIssueError.data.paymentOptions.paymentMethods[i].type === this.PmtConstants.PAYMENT_TYPES.ONHOLD) {
                        foundOHMethod = i;
                    }
                    if ( [this.PmtConstants.PAYMENT_TYPES.ONHOLD_IBERIA_PAY_AFOP, this.PmtConstants.PAYMENT_TYPES.IBERIA_PAY_AFOP].includes(dataIssueError.data.paymentOptions.paymentMethods[i].type)
                            && ((dataIssueError.data.paymentOptions.paymentMethods[i].provider === this.PmtConstants.PAYMENT_TYPES.PAYPAL && this.$window.paypal)
                                || (dataIssueError.data.paymentOptions.paymentMethods[i].provider === this.PmtConstants.PAYMENT_TYPES.NEMURU && this.$window.Nemuru)
                            )) {
                        dataIssueError.data.paymentOptions.paymentMethods[i].scriptdownloaded = 'success';
                    }
                }
                if (!isNaN(foundOHMethod)) {
                    this.PmtUtilsService.updateOnHoldOptions(dataIssueError.data.paymentOptions, foundOHMethod);
                    dataIssueError.data.paymentOptions.paymentMethods.splice(foundOHMethod, 1);
                }
            }
            this.updatePaymentsWithoutCall(dataIssueError.data);
            this.model.selectedData.selectedOnHoldIndex = this.localStorageService.get('onHoldOptionSelected') ? this.localStorageService.get('onHoldOptionSelected') : 0;
            this.localStorageService.set('noShowMessageBockBack', true);
            this.localStorageService.set('payFlowBackBlock', true);
            if (this.localStorageService.get('userLogged')) {
                if (this.model.paymentInfo.paymentMethods[0].type !== 'IBERIA_PAY' || this.model.paymentInfo.customerCreditCards.IBERIA_PAY.length > 1 || this.model.paymentInfo.paymentMethods[0].type !== 'ONHOLD_IBERIA_PAY' || this.model.paymentInfo.customerCreditCards.ONHOLD_IBERIA_PAY.length > 1) {
                    this.model.paymentInfo.iberiaPayLoadingIframe = false;
                }
            }
        } else if (dataIssueError && this.isShuttleFlow && dataIssueError !== null && dataIssueError.errorCode === 412) {
            this.updateDatalayerWithQuadrigam(this.localStorageService.get('pmtModelInfo').quadrigams.error, null, this.PmtUtilsService.isUserLogged());
        } else {
            this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ONHOLD ? this.PmtModalService.showWaitingModal() : this.PmtModalService.showWaitingModal('ib-modal-loading-plane-pmt', 'ib-modals ib-modals--transparent', true);
            this.PmtUtilsService.initStorage();
            this.localStorageService.set('nextStepAllowed', true);
            this.dataRequest = this.PmtTransformer.getPaymentsModel();
            if (!this.isShuttleFlow && this.flowApp !== this.PmtConstants.APP_TYPES.GIFTCARDS) {

                this.updateDatalayerWithQuadrigam(this.localStorageService.get('pmtModelInfo')?.quadrigams.payments, this.localStorageService.get('confirmationDatalayerInfo'), this.PmtUtilsService.isUserLogged());
            } else if (this.flowApp !== this.PmtConstants.APP_TYPES.GIFTCARDS) {
                orderData = this.localStorageService.get('createOrderData');
                /* INIT DELETE GA4 MIGRATION*/
                paDatalayerObject = this.localStorageService.get('pmtModelInfo');
                paDatalayerObject.CurrencySymbol = orderData.contextMetadata.currencies[0].code;

                paDatalayerObject.SearchDest = orderData.order.slices[0].segments[0].arrival.city.code;
                paDatalayerObject.SearchOrigin = orderData.order.slices[0].segments[0].departure.city.code;
                paDatalayerObject.TotalPrice = (orderData.order.price.total).toString();
                paDatalayerObject.TotalPriceNoTaxFee = (orderData.order.price.fare).toString();
                delete paDatalayerObject.ident;
                delete paDatalayerObject.quadrigams;
                delete paDatalayerObject.issueCountry;
                this.DatalayerUtilsService.updateDatalayerWithQuadrigam(this.localStorageService.get('pmtModelInfo').quadrigams.payments, paDatalayerObject, this.PmtUtilsService.isUserLogged());
                /* FINISH DELETE GA4 MIGRATION*/
                paDigitalDataObject = this.localStorageService.get('pmtModelInfo');
                paDigitalDataObject.CurrencySymbol = orderData.contextMetadata.currencies[0].code;
                paDigitalDataObject.SearchDest = orderData.order.slices[0].segments[0].arrival.city.code;
                paDigitalDataObject.SearchOrigin = orderData.order.slices[0].segments[0].departure.city.code;
                paDigitalDataObject.TotalPrice = (orderData.order.price.total).toString();
                paDigitalDataObject.TotalPriceWithoutTaxes = (orderData.order.price.fare).toString();
                delete paDigitalDataObject.ident;
                delete paDigitalDataObject.quadrigams;
                delete paDigitalDataObject.issueCountry;
                this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(this.localStorageService.get('pmtModelInfo').quadrigams.payments, paDigitalDataObject, this.PmtUtilsService.isUserLogged());
            }
            const checkOnHoldConditions = (ident, issueCountry, serviceURI) => {
                const isUserLogged = this.PmtUtilsService.isUserLogged() ?? null;
                const bookingInfo = this.localStorageService.get('bookingInfo') ?? null;
                const voucherCode = `${bookingInfo?.order?.voucherDiscount?.partnerId}/${bookingInfo?.order?.voucherDiscount?.productId}` ?? null;
                const hasPartnerDiscount = bookingInfo?.order?.voucherDiscount?.type === this.PmtConstants.DISCOUNT_TYPES.PARTNER ?? null;
                if (!isUserLogged && hasPartnerDiscount) {
                    return this.PMTCheckPartnerDiscountsService.deletePartnerDiscount(serviceURI, voucherCode, ident)
                        .then((data) => {
                            const savedBookingInfo = this.localStorageService.get('bookingInfo') ?? null;
                            savedBookingInfo.order = data.order;
                            this.localStorageService.set('bookingInfo', savedBookingInfo);
                            return this.PmtService.getPaymenMethodsInfo(ident, issueCountry, serviceURI);
                        })
                        .catch((error) => {
                            return this.PmtService.getPaymenMethodsInfo(ident, issueCountry, serviceURI);
                        });
                } else {
                    return this.PmtService.getPaymenMethodsInfo(ident, issueCountry, serviceURI);
                }
            };

            const pmtMethodsPromise = this.flowApp !== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ONHOLD ? this.PmtService.getPaymenMethodsInfo(this.dataRequest?.ident, this.dataRequest?.issueCountry, this.$rootScope.serviceURI) : checkOnHoldConditions(this.dataRequest?.ident, this.dataRequest?.issueCountry, this.$rootScope.serviceURI);
            pmtMethodsPromise.then((data) => {
                let headerModelData;
                const quadrigam = this.localStorageService.get('pmtModelInfo')?.quadrigams.payments;
                if (Object.keys(data.summaryInfo).length > 0 && (data.summaryInfo.ancillaries && Object.keys(data.summaryInfo.ancillaries).length > 0) && this.localStorageService.get('flowApp') !== this.PmtConstants.APP_TYPES.CHECKIN) {
                    ancillariesTotalUpdate = this.DatalayerEcommerceUtilsService.updateDatalayerWithAncillaries(data.summaryInfo.ancillaries.total ? data.summaryInfo.ancillaries.total : data.summaryInfo.ancillaries.generalInfo ? data.summaryInfo.ancillaries.generalInfo.totalPrice : 0);
                } else if (this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.CHECKIN) {
                    ancillariesTotalUpdate = this.DatalayerEcommerceUtilsService.updateDatalayerWithAncillaries(data.paymentInfo.price.totalPrice);
                } else if (this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE || this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED) {
                    ancillariesTotalUpdate = this.DatalayerEcommerceUtilsService.updateDatalayerVoluntaryChanges(data);
                }
                const datalayerConfirmation = Object.assign(this.localStorageService.get('confirmationDatalayerInfo') ?? {}, ancillariesTotalUpdate ?? {});
                this.updateDatalayerWithQuadrigam(this.localStorageService.get('pmtModelInfo')?.quadrigams.payments, datalayerConfirmation, this.PmtUtilsService.isUserLogged());
                if (this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.BOOKING) {
                    /* INIT DELETE GA4 MIGRATION*/
                    const voucherElect = this.PmtUtilsService.voucherSelected(data.paymentInfo.appliedDiscounts);
                    this.isShuttleFlow ? this.DatalayerUtilsService.addShuttleDatalayer(this.localStorageService.get('actualStepFlow'), this.model): '';
                    this.DatalayerUtilsService.addDataLayerInfo(voucherElect);
                    /* FINISH DELETE GA4 MIGRATION*/
                    const eligibleVoucherElect = this.PmtUtilsService.eligibleVoucherSelected(data.paymentInfo.appliedDiscounts);
                    this.isShuttleFlow ? this.DatalayerUtilsService.addShuttleDigitalData(this.localStorageService.get('actualStepFlow'), this.model): '';
                    this.DatalayerUtilsService.addDigitalDataInfo(eligibleVoucherElect);
                }
                /* INIT DELETE GA4 MIGRATION */
                this.DatalayerUtilsService.sendDatalayerEvent(this.PmtDatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
                /* FINISH DELETE GA4 MIGRATION */
                this.DigitalDataService.emitViewEvent();
                this.DatalayerEcommerceUtilsService.setAddPaymentInfo();
                if (this.localStorageService.get('flowApp') !== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING || this.localStorageService.get('flowApp') !== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ONHOLD) {
                    this.MonetateUtilsService.updateMonetateWithQuadrigam(this.PmtConstants.MONETATE_INFO.SETPAGETYPE, this.localStorageService.get('pmtModelInfo')?.quadrigams.payments);
                }
                this.PmtModalService.finishWaiting();
                this.$timeout(() => {
                    if (this.localStorageService.get('flowApp') !== this.PmtConstants.APP_TYPES.BOOKING) {
                        this.$rootScope.$broadcast('sendUpdateToMonetate');
                    }
                });

                this.$timeout(() => {
                    if (this.localStorageService.get('selectedFlex') && this.$rootScope.ancOffers) {
                        const flexAvailable = this.localStorageService.get('selectedFlex');
                        this.NewMainHeaderFacade.updateBasketFlexibilization('');
                        this.NewMainHeaderFacade.updateBasketFlexibilization(flexAvailable);
                    }
                });

                this.model = data;
                this.getCcFeeRequest(data.paymentInfo?.price.totalPrice, data.paymentInfo?.currency, this.dataRequest?.issueCountry, data.summaryInfo?.trips);
                if (this.localStorageService.get('addedCartProductCollection')) {
                    this.localStorageService.remove('addedCartProductCollection');
                }
                if (this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.BOOKING) {
                    this.$timeout(() => {
                        this.trackInfoToMonetate();
                    });
                }
                if (donationData) {
                    this.checkDonation('event', true, donationData.option, donationData.donationInfo, donationData.form ? donationData.form.acceptDonationData : null, donationData.form ? donationData.form : null);
                }
                this.$timeout(() => {
                    if (this.localStorageService.get('selectedFlex') && this.$rootScope.ancOffers) {
                        this.model.paymentInfo.price.formattedTotalPrice = this.localStorageService.get('headerModel').headerModel.shoppingBasket.total.formatted;
                        this.model.paymentInfo.price.totalPrice = this.localStorageService.get('headerModel').headerModel.shoppingBasket.total.original;
                    }
                });
                this.localStorageService.set('modelPaymentData', this.model);
                this.localStorageService.set('paymentMethodsWithoutDiscount', this.model.paymentInfo?.paymentMethods);
                if (this.model.paymentInfo?.paymentMethods[0].type === 'ONHOLD' || this.model.paymentInfo?.paymentMethods[0].type === 'ONHOLD_CREDITCARD' || this.model.paymentInfo?.paymentMethods[0].type === 'ONHOLD_IBERIA_PAY') {
                    this.NewMainHeaderFacade.updateBasketOthers(this.model.paymentInfo.paymentMethods[0].type, this.model.paymentInfo.paymentMethods[0]);
                }
                if (this.localStorageService.get('userLogged')) {
                    if ((this.model.paymentInfo.paymentMethods[0].type !== 'IBERIA_PAY' && this.model.paymentInfo.paymentMethods[0].type !== 'ONHOLD_IBERIA_PAY') || (this.model.paymentInfo.customerCreditCards.IBERIA_PAY && this.model.paymentInfo.customerCreditCards.IBERIA_PAY.length > 1) || (this.model.paymentInfo.customerCreditCards.ONHOLD_IBERIA_PAY && this.model.paymentInfo.customerCreditCards.ONHOLD_IBERIA_PAY.length > 1)) {
                        this.model.paymentInfo.iberiaPayLoadingIframe = false;
                    }
                }
                if (orderData?.order) {
                    this.NewMainHeaderFacade.updateTripsFromOrder(orderData);
                    // Update total price according to payment method
                    headerModelData = this.localStorageService.get('headerModel');
                    headerModelData.headerModel.shoppingBasket.total.totalPrice = this.model.paymentInfo.price.totalPrice;
                    headerModelData.headerModel.shoppingBasket.total.formatted = this.model.paymentInfo.price.formattedTotalPrice;
                    this.NewMainHeaderFacade.updateHeaderModel(headerModelData);

                    if (orderData.order?.discountsApplied?.discounts?.length > 0) {
                        angular.forEach(orderData.order.discountsApplied.discounts, (discount) => {
                            // ADD all discounts on BKI ONHOLD
                            const maptype = (this.PmtConstants.DISCOUNT_TYPES.PARTNER !== discount.type) ? discount.type : this.PmtConstants.DISCOUNT_TYPES.VOUCHER;

                            if (this.flowApp === this.PmtConstants.APP_TYPES.ONHOLD || (!this.CommonsUtilService.isDiscountTypePartnerEquivalent(discount.type) && (discount.type !== this.PmtConstants.DISCOUNT_TYPES.PARTNER) && (discount.type !== this.PmtConstants.DISCOUNT_TYPES.VOUCHER))) {
                                this.model.paymentInfo.appliedDiscounts.types[maptype] = discount;
                                this.model.paymentInfo.appliedDiscounts.types[maptype].originalDiscount = discount.totalDiscount;
                                this.model.paymentInfo.appliedDiscounts.types[maptype].discount = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.appliedDiscounts.types[maptype].originalDiscount, true);
                                this.model.paymentInfo.appliedDiscounts.types[maptype].discountFormatted = this.model.paymentInfo.appliedDiscounts.types[maptype].discount;
                            }
                        });
                        headerModelData.headerModel.shoppingBasket.discountsModel.discounts = this.model.paymentInfo?.appliedDiscounts?.types ?? {};
                        headerModelData.headerModel.shoppingBasket.discountsModel.hasDiscounts = Object.keys(headerModelData.headerModel.shoppingBasket.discountsModel.discounts).length > 0;
                        this.NewMainHeaderFacade.updateHeaderModel(headerModelData);
                        this.model.paymentInfo.appliedDiscounts.status = headerModelData.headerModel.shoppingBasket.discountsModel.hasDiscounts;

                        this.updateDisccountsTotal(false, this.model.paymentInfo.appliedDiscounts.types);
                        headerModelData = this.localStorageService.get('headerModel');
                    }
                    this.DatalayerUtilsService.updateDiscountData(orderData.order?.specialDiscounts ?? []);
                }
                if (this.flowApp === this.PmtConstants.APP_TYPES.ONHOLD) {
                    const onHoldInfo = {...this.model.paymentInfo.onHoldInfo};
                    if (this?.model?.paymentInfo?.appliedDiscounts?.types?.[this.PmtConstants.DISCOUNT_TYPES.VOUCHER] && this?.model?.paymentInfo?.appliedDiscounts?.types?.[this.PmtConstants.DISCOUNT_TYPES.VOUCHER].type === this.PmtConstants.DISCOUNT_TYPES.PARTNER) {
                        onHoldInfo.totalPriceBooking-=this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER].totalDiscount;
                    }
                    this.updateBasketOnHold(onHoldInfo, this.model.paymentInfo.appliedDiscounts.types);
                }
                this.updateTotalFees();

                this.$timeout(() => {
                    angular.element(this.$window).triggerHandler('resize');
                });

            }, (error) => {
                const hasReason = !!(error.errorData && error.errorData.data && error.errorData.data.errors.length > 0);
                if ((this.localStorageService.get('flowApp') !== 'MMBVC' && this.localStorageService.get('flowApp') !== 'MMBUNIF') || (error.errorData.errorCode !== 412 && hasReason && error.errorData.data.errors[0].code !== 'PMT_PPM_9009')) {
                    this.PmtModalService.finishWaiting();
                }
            });
        }
        if (this.localStorageService.get('userLogged') === this.PmtConstants.LOGIN_ONB) {
            this.isONBFlow = true;
            if (this.localStorageService.get('pointsChecked')) {
                this.oBPoints = this.localStorageService.get('oBPoints');
                this.showOBPoints = 'SHOW';
                if (this.localStorageService.get('discountsAndPoints')) {
                    this.noDiscountOBPrice = this.localStorageService.get('noDiscountOBPriceUpdated') ? this.localStorageService.get('noDiscountOBPriceUpdated') : this.localStorageService.get('noDiscountOBPrice');
                    this.originalOBPrice = this.localStorageService.get('originalOBPrice');
                    this.showNoDiscountOBPrice = this.localStorageService.get('showNoDiscountOBPrice');
                }
            } else {
                this.noDiscountOBPrice = this.localStorageService.get('noDiscountOBPriceUpdated') ? this.localStorageService.get('noDiscountOBPriceUpdated') : this.localStorageService.get('noDiscountOBPrice');
                this.originalOBPrice = this.localStorageService.get('originalOBPrice');
                this.showNoDiscountOBPrice = this.localStorageService.get('showNoDiscountOBPrice');
            }
        }
        angular.element(this.$window).triggerHandler('resize');
        pointsData = this.localStorageService.get('CalculatedPoints');
        this.aviosToEarn = pointsData ? pointsData.Avios : 0;
        this.elitePointsToEarn = pointsData ? pointsData.Elite : 0;
        fareData = this.localStorageService.get('fareData');
        bookingInfo = this.localStorageService.get('bookingInfo');


        this.nemuruAvailableObserver= this.ibPmtNemuruService.nemuruIsAvailableObser.subscribe(currentStatus =>{this.nemuruIsCalled = currentStatus; });
        this.mercadoPagoAvailableObserver= this.ibPmtMercadoPagoService.mercadoPagoIsAvailableObserver.subscribe(currentStatus =>{
            this.mercadoPagoIsCalled = currentStatus;
        });

        if (fareData && fareData.offers[0] && fareData.offers[0].price && fareData.offers[0].price.ticketingFee) {
            this.NewMainHeaderFacade.updateBasketOthers('SUMMARY_OTHER_FEES_ADMINISTRATION', {
                code: 'ticketingFee',
                description: 'SUMMARY_OTHER_FEES_ADMINISTRATION',
                parsedFee: this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(fareData.contextMetadata.currencies[0]), fareData.offers[0].price.ticketingFee, true),
                totalFee: fareData.offers[0].price.ticketingFee
            });
            this.updateTotalFees();
        }
    };

    updateAviosCalculated = () => {
        const pointsData = this.localStorageService.get('CalculatedPoints');
        this.aviosToEarn = pointsData ? pointsData.Avios : 0;
        this.elitePointsToEarn = pointsData ? pointsData.Elite : 0;
    };

    aviosCalculatedError = () => {
        this.aviosToEarn =  0;
        this.elitePointsToEarn =  0;
    };


    $onDestroy = ()=>{
        this.nemuruAvailableObserver.unsubscribe();
        this.dccDataObersever.unsubscribe();
    };



    trackInfoToMonetate = () => {
        const bookingUrlParams = this.localStorageService.get('bookingUrlParams');
        this.trackShoppingBasketInMonetate(this.model.summaryInfo.ancillaries);
        this.trackPassengersFlightInMonetate(bookingUrlParams);
        this.trackFlightCabinInMonetate(this.localStorageService.get('fareData'), this.localStorageService.get('bookingUrlParams'));
        this.trackTripTypeInMonetate(bookingUrlParams.originDestinations);
        this.trackFareTypeSelectedInMonetate(this.localStorageService.get('fareFamilyConditionsInfo'));
        this.trackFlightDestinationInMonetate(this.localStorageService.get('destinationAreasCitiesList'), bookingUrlParams.originDestinations);
        this.$rootScope.$broadcast('sendUpdateToMonetate');
    };

    trackShoppingBasketInMonetate = (ancillaries) => {
        if (ancillaries) {
            this.MonetateUtilsService.trackAncillariesProductsAdded(ancillaries, this.MonetateConstants.TRACK_PLACE.CART);
        }
    };

    trackPassengersFlightInMonetate = (passengersInfo) => {
        if (passengersInfo) {
            this.MonetateUtilsService.trackFlightPassengers(passengersInfo);
        }
    };

    trackFlightCabinInMonetate = (selectedTripInfo, bookingUrlParams) => {
        if (selectedTripInfo && selectedTripInfo.fareFamilyConditions && selectedTripInfo.fareFamilyConditions.length > 0 && bookingUrlParams && bookingUrlParams.preferredCabin) {
            this.MonetateUtilsService.trackFlightCabin(selectedTripInfo.fareFamilyConditions, bookingUrlParams.preferredCabin);
        }
    };

    trackTripTypeInMonetate = (originDestinationInfo) => {
        if (originDestinationInfo && originDestinationInfo.length > 1) {
            this.MonetateUtilsService.trackTripType(originDestinationInfo);
        }
    };

    trackFareTypeSelectedInMonetate = (fareFamilyConditionsInfo) => {
        if (fareFamilyConditionsInfo) {
            this.MonetateUtilsService.trackFareTypeSelected(fareFamilyConditionsInfo);
        }
    };

    trackFlightDestinationInMonetate = (destinationAreasCitiesList, destinationCountry) => {
        if (!destinationAreasCitiesList) {
            this.GetDestinationsService.getDestinationAreasCitiesList().then(data => destinationAreasCitiesList = data.data);
        }
        if (destinationAreasCitiesList && destinationCountry) {
            this.MonetateUtilsService.trackFlightDestination(destinationAreasCitiesList, destinationCountry);
        }
    };
    getCcFeeRequest = (totalPrice, currency, market, tripInfo) => {

        const priceObject = { price: totalPrice * Math.pow(10, currency?.numberDecimals), decimals: currency?.numberDecimals}, request = {
            paymentPrice: {
                price: priceObject.price,
                currency: currency?.code + priceObject.decimals
            },
            channel: 'NEW_WEB',
            client: 'IB',
            market: market
        };
        if(tripInfo && tripInfo[0] && tripInfo[0].segments[0]) {
            let indexArrivalTrip = tripInfo.length - 1;
            let indexArrivalSegment = tripInfo[indexArrivalTrip].segments.length - 1;
            const getDepartureCityCode = () => tripInfo[0].segments[0].departure.city.code;
            const getArrivalCityCode  = () => tripInfo[indexArrivalTrip].segments[indexArrivalSegment].arrival.city.code;
            if(getDepartureCityCode() === getArrivalCityCode()) {
                if(tripInfo.length === 2) { // return trip
                    indexArrivalTrip = 0;
                }
                if(tripInfo.length > 2) { // multiple trips
                    const arrivals = [];
                    const originDeparture = getDepartureCityCode();
                    tripInfo.forEach((trip, indexTrip) => {
                        trip.segments.forEach((segment, indexSegment) => {
                            const arrival = segment.arrival.city.code;
                            if(!arrivals.includes(arrival) && arrival !== originDeparture) {
                                arrivals.push(segment.arrival.city.code);
                                indexArrivalTrip = indexTrip;
                                indexArrivalSegment = indexSegment;
                            }
                        });
                    });
                }
            }
            angular.extend(request, {
                departureLocation: {
                    countryCode: tripInfo[0].segments[0].departure.city.country.code,
                    cityCode: getDepartureCityCode(),
                    airportCode: tripInfo[0].segments[0].departure.code
                },
                arrivalLocation: {
                    countryCode: tripInfo[indexArrivalTrip].segments[indexArrivalSegment].arrival.city.country.code,
                    cityCode: getArrivalCityCode(),
                    airportCode: tripInfo[indexArrivalTrip].segments[indexArrivalSegment].arrival.code
                }
            });
        }
        this.localStorageService.set('ibpayCcFeeRequest', request);
    };

    /**
     * This function Continue with pay calling service
     * @param {Event} submitedPaymentEvent event to lunch function
     * @param {Boolean} isRecal Parameter that indicates if the payment is 3ds and it is necessary to perform the callback
     * @param {Boolean} tokenizeSucces Parameter that indicates if the payment with Iberia pay has been successful and continues with the payment flow
     * @param {Boolena} onHoldPaymentPcc Parameter that indicates if the user select option onhold when issue return 449 error pcc
     */
    submitPayment = (event?, isRecal?, tokenizeSucces?, onHoldPaymentPcc?) => {
        const fullAviosError = (error) => {
            this.PmtModalService.finishWaiting();
            this.model.paymentInfo.fullAvios = false;
        };
        const getPaymentType = () => {
            let paymentType = null;
            const paymentInfo = this.localStorageService.get('paymentsInfo');
            if (this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === this.PmtConstants.PAYMENT_TYPES.VOUCHER) {
                paymentType = this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type;
            } else if (paymentInfo.fullAvios) {
                paymentType = this.PmtConstants.PAYMENT_TYPES.FULL_AVIOS;
            } else {
                paymentType = this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].description +
                    ((this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === 'CREDITCARD' || this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === 'IBERIA_PAY') && this.model.paymentInfo.selectedPaymentInfo.selectedCard ? ' ' + this.model.paymentInfo.selectedPaymentInfo.selectedCard.description : '');
                this.localStorageService.set('paymentProvider', this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].provider);
            }
            return paymentType;
        };
        /* INIT DELETE GA4 MIGRATION*/
        const datalayer_general = this.$window.datalayer_general;
        /* FINISH DELETE GA4 MIGRATION*/
        this.digital_data =  this.$window.digital_data;
        let redirectionInfo = this.localStorageService.get('redirectionPaymentCallback'), flowApp = this.localStorageService.get('flowApp'), passengersContactData = null, typeIndex, typeFind,
            notTokenize = !!(this.localStorageService.get('userLogged') && this.model.paymentInfo.selectedPaymentInfo && this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard && this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard.cardTypeCode === 'TP'|| this.model.paymentInfo.selectedPaymentInfo?.selectedLoggedCard?.cof),
            paymentTransition = this.model.selectedData?.selectedTab? this.model.paymentInfo?.paymentMethods[this.model.selectedData.selectedTab]?.provider : 'CREDIT_CARD' || 'CREDIT_CARD', offerSelection = false;
        if(this.localStorageService.get('flowApp').indexOf('BKI') >= 0) {
            if(event) {
                this.DatalayerEcommerceUtilsService.setDonationsAddToCart(this.model.summaryInfo.orderFees);
            }
        }
        if (!this.quotaIsLoading) {
            this.localStorageService.set('noShowMessageBockBack', true);
            delete this.quotaIbPayCall;
            this.DatalayerUtilsService.removeDatalayerModalAttrs();
            this.localStorageService.set('summaryAncillaries', this.model.summaryInfo.ancillaries);
            if (!this.model.paymentInfo.fullAvios && this.model.paymentInfo.appliedDiscounts && this.model.paymentInfo.appliedDiscounts.status && this.model.paymentInfo.appliedDiscounts.types.AVIOS && this.model.paymentInfo.price.totalPrice === 0) {
                this.PmtModalService.showWaitingModal('ib-modal-pmt-cards', 'ib-modals ib-modals--transparent', true, { transition: 'CREDIT_CARD' });
                this.PmtService.checkFullAvios(this.model.paymentInfo.appliedDiscounts.types.AVIOS.id).then((response) => {
                    if (response.isFullAvios) {
                        this.model.paymentInfo.fullAvios = true;
                        const issueCountry = this.localStorageService.get('selectedIssuerCountry') ? this.localStorageService.get('selectedIssuerCountry').code : this.model.generalData.issuerCountry.code;
                        this.model.showOptions.loadingPaymentData = true;
                        this.localStorageService.set('numeroAvios', this.model.paymentInfo.appliedDiscounts.types.AVIOS.formatedAvios);
                        if (this.localStorageService.get('creditCardFee')) {
                            this.localStorageService.remove('creditCardFee');
                        }
                        this.PmtService.submitFullAvios(this.dataRequest.ident, issueCountry, this.$rootScope.serviceURI).then((response) => {
                            this.PmtModalService.finishWaiting();
                            this.localStorageService.set('paymentType', getPaymentType());
                            this.goToConfirmationPage();
                        }, fullAviosError);
                    } else {
                        fullAviosError(response.fullAvios);
                    }
                }, fullAviosError);
            } else {
                if (paymentTransition === 'IDEAL') paymentTransition = 'SOFORT';
                this.PmtModalService.showWaitingModal('ib-modal-pmt-cards', 'ib-modals ib-modals--transparent', true, {transition: paymentTransition});
                if (flowApp === this.PmtConstants.APP_TYPES.CHECKIN && this.paymentsForm && this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === this.PmtConstants.PAYMENT_TYPES.EXTERNAL_CREDITCARD) {
                    passengersContactData = this.localStorageService.get('passengersContactData');
                    if (passengersContactData) {
                        this.model.paymentInfo.requiredAdditionalFields.info.EXTERNAL_CREDITCARD.PAYER.requiredFields.EMAIL = { email: passengersContactData[0].email };
                        this.model.paymentInfo.requiredAdditionalFields.info.EXTERNAL_CREDITCARD.PAYER.requiredFields.PHONE = { phone: passengersContactData[0].phone };
                    }

                }
            }
            if (flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE || flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED) {
                this.localStorageService.set('RechargeBookingInfo', true);
            }
            if (onHoldPaymentPcc) {
                this.localStorageService.remove('summaryAncillaries');
                this.dataRequest = this.PmtTransformer.getPaymentsModel();
                this.DatalayerEcommerceUtilsService.updateAddToCartInfoOnHold();
            }
            this.numberCallEvent++;
            /* INIT DELETE GA4 MIGRATION*/
            if (datalayer_general && angular.isObject(datalayer_general)) {
                this.localStorageService.set('confirmationDatalayerCallBack', datalayer_general);
                this.localStorageService.set('confirmationDatalayerInfo', datalayer_general);
            }
            /* FINISH DELETE GA4 MIGRATION*/
            if (this.digital_data && angular.isObject(this.digital_data)) {
                this.localStorageService.set('confirmationDigitalDataCallBack', this.digital_data);
                this.localStorageService.set('confirmationDigitalInfo', this.digital_data);
            }
            if ((this.model.paymentInfo.paymentMethods && (this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === this.PmtConstants.PAYMENT_TYPES.IBERIA_PAY || this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === this.PmtConstants.PAYMENT_TYPES.ONHOLD_IBERIA_PAY)) && !tokenizeSucces && !redirectionInfo && !onHoldPaymentPcc && !isRecal && !notTokenize) {
                if (this.model.paymentInfo.selectedPaymentInfo.cardTypeId || (this.model.paymentInfo.selectedPaymentInfo.selectedCard && this.model.paymentInfo.selectedPaymentInfo.selectedCard.cardTypeId) || (this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard && this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard.cardTypeId)) {
                    this.numberCallEvent = 0;
                    this.$window.IBDC.tokenizeCreditCard();
                } else {
                    typeIndex = 0;
                    while (!typeFind && typeIndex < this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].creditCardTypes.length) {
                        if (this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].creditCardTypes[typeIndex].cardTypeCode === this.localStorageService.get('typeCardIberiaPay')) {
                            typeFind = this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].creditCardTypes[typeIndex];
                        }
                        typeIndex++;
                    }
                    if (typeFind) {
                        this.model.paymentInfo.selectedPaymentInfo.selectedCard = typeFind;
                        this.numberCallEvent = 0;
                        this.$window.IBDC.tokenizeCreditCard();
                    } else {
                        this.iberiaPayErrorsControll({ detail: { resultValidCard: 500, message: 'no type for this card detected' } });
                    }
                }
            } else if (this.numberCallEvent === 1) {
                if (this.localStorageService.get('errorIssueService')) {
                    this.model.paymentInfo.paymentId = this.localStorageService.get('errorIssueService').data.paymentOptions.paymentId;
                }
                if (this.model.noPaymentSummary) {
                    this.noPaymentConfirm();
                } else {
                    this.localStorageService.set('paymentType', getPaymentType());
                    if (getPaymentType() === 'Transferencia') {
                        this.localStorageService.set('payFromTransfer', true);
                    }
                    if (this.currentDccData && !this.donationEnabled && (this.currentDccData.selectedValue === this.PmtConstants.PAYMENTS_DCC.DCC_ENABLED || this.currentDccData.selectedValue === undefined && this.currentDccData.creditCardType === this.PmtConstants.PAYMENTS_DCC.VISA)) offerSelection = true;
                    this.PmtService.submitPayment(this.model, this.$rootScope.serviceURI, isRecal, onHoldPaymentPcc, offerSelection).then((response) => {
                        this.numberCallEvent = 0;
                        this.localStorageService.set('fullIssuedPaiment', response);
                        this.PmtModalService.finishWaiting();
                        this.deletePrivateData();
                        this.localStorageService.set('nextStepAllowed', false);
                        if (this.asComponent) {
                            switch (flowApp) {
                                    case this.PmtConstants.APP_TYPES.CHECKIN: this.$scope.$emit('changeStep', this.PmtConstants.COMPONENT_PAGE.PAYMENTS_PAGE, this.PmtConstants.COMPONENT_PAGE.CKI_BOARDING_CARD_PAGE); break;
                                    case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ANCILLARIES: this.$scope.$emit('changeStep', this.PmtConstants.COMPONENT_PAGE.PAYMENTS_PAGE, this.PmtConstants.COMPONENT_PAGE.MMB_CONFIRMATION_PAGE); break;
                                    case this.PmtConstants.APP_TYPES.SUBSCRIPTIONMODELS: this.$scope.$emit('changeStep', this.PmtConstants.COMPONENT_PAGE.PAYMENTS_PAGE, this.PmtConstants.COMPONENT_PAGE.SUBSCRIPTION_MODELS_CONFIRMATION_PAGE); break;
                                    default: this.$scope.$emit('changeStep', this.PmtConstants.COMPONENT_PAGE.PAYMENTS_PAGE, this.PmtConstants.COMPONENT_PAGE.CONFIRMATION_PAGE); break;
                            }
                        } else {
                            history.pushState(null, null, location.href);
                            switch (flowApp) {
                                    case this.PmtConstants.APP_TYPES.CHECKIN: this.updateDatalayerInformationCkiFlow();
                                        this.$location.path(this.PmtConstants.PAGES_URL.CKI_BOARDING_CARD_PAGE);
                                        break;
                                    case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ANCILLARIES:
                                        this.$location.path(this.PmtConstants.PAGES_URL.MMB_CONFIRMATION_PAGE);
                                        break;
                                    case this.PmtConstants.APP_TYPES.GIFTCARDS:
                                        this.$location.path(this.PmtConstants.PAGES_URL.GIFTCARDS_CONFIRMATION_PAGE);
                                        break;
                                    case this.PmtConstants.APP_TYPES.SUBSCRIPTIONMODELS:
                                        this.$location.path(this.PmtConstants.PAGES_URL.SUBSCRIPTION_MODELS_CONFIRMATION_PAGE);
                                        break;
                                    default: this.$location.path(this.PmtConstants.PAGES_URL.CONFIRMATION_PAGE);
                            }
                        }
                    }, () => {
                        this.numberCallEvent = 0;
                        if (!this.loadingOnlineBankingForm && !this.loadingIframeForm) {
                            this.PmtModalService.finishWaiting();
                        }
                    });
                }
            }
        }
    };



    /**
     * Update the 'fee' information and launch an event to the child component to update information.
     * Controll that card selected in combo correspond with credit card number insert in IFRAME IberiaPay.
     * @param {Event} changeSelectedCreditCard event to launch function
     * @param {Object} selectedCard Is object with all credit card information
     */
    updateSelectedCardFields = (event, selectedCard) => {
        const typeCardIberiaPay = this.localStorageService.get('typeCardIberiaPay') || null;

        this.updateFee(selectedCard);
        this.$scope.$broadcast('cardChanged', selectedCard);
    };
    /**
     * Update the 'fee' information when select an user credit card
     * @param {*} event
     * @param {Object} selectedCard Is object with all credit card information
     */
    updateUserSelectedCreditCard = (event, selectedCard) => {
        if (this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === 'IBERIA_PAY' && this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab]?.cof=== false) {

            this.model.paymentInfo.iberiaPayLoadingIframe = true;
        }
        this.updateFee(selectedCard);
    };
    /**
     * Update the 'fee' information
     * @param {*} selectedCard
     */
    updateFee (selectedCard) {
        let foundedOtherFee = false, foundedDonation = false, foundedDonationIndex, orderFeesIndex = 0, creditCardFeeIndex = 0, oldFee = this.localStorageService.get('creditCardFee') ? this.localStorageService.get('creditCardFee').totalFee : null, hasBasketDiscountsApplied = false, createOrderData: any = {}, headerModelData: any = {};
        if (selectedCard) {
            headerModelData = this.localStorageService.get('headerModel');
            createOrderData = this.localStorageService.get('createOrderData');
            if (createOrderData && createOrderData.order && createOrderData.order.discountsApplied && createOrderData.order.discountsApplied.discounts && createOrderData.order.discountsApplied.discounts.length > 0) {
                hasBasketDiscountsApplied = true;
            }
            if (selectedCard.cardTypeId === 'newCard') {
                this.model.paymentInfo.selectedPaymentInfo.selectedCard = null;
            }
            if (this.model.summaryInfo.orderFees && this.model.summaryInfo.orderFees.length > 0) {
                while ((!foundedOtherFee || !foundedDonation) && orderFeesIndex < this.model.summaryInfo.orderFees.length) {
                    if (this.model.summaryInfo.orderFees[orderFeesIndex].code === 'creditCardFee') {
                        this.model.summaryInfo.orderFees[orderFeesIndex].fee = selectedCard && selectedCard.parsedFee ? selectedCard.parsedFee : null;
                        this.model.summaryInfo.orderFees[orderFeesIndex].totalFee = selectedCard && selectedCard.totalFee ? selectedCard.totalFee : null;
                        foundedOtherFee = true;
                        creditCardFeeIndex = orderFeesIndex;
                        this.localStorageService.set('creditCardFee', this.model.summaryInfo.orderFees[orderFeesIndex]);
                        this.NewMainHeaderFacade.updateBasketOthers('CARD', selectedCard);
                    } else if (this.model.summaryInfo.orderFees[orderFeesIndex].code === 'donation') {
                        foundedDonationIndex = orderFeesIndex;
                        foundedDonation = true;
                    }
                    orderFeesIndex++;
                }
            }
            if (selectedCard.totalFee !== 0 && selectedCard.fee && !foundedOtherFee) {
                if (angular.isUndefined(this.model.summaryInfo.orderFees)) {
                    this.model.summaryInfo.orderFees = [];
                }
                this.model.summaryInfo.orderFees.push({
                    code: 'creditCardFee',
                    description: 'SUMMARY_OTHER_FEES_CREDIT_CARD',
                    fee: selectedCard.parsedFee,
                    totalFee: selectedCard.totalFee
                });
                this.localStorageService.set('creditCardFee', this.model.summaryInfo.orderFees[orderFeesIndex]);
                this.NewMainHeaderFacade.updateBasketOthers('CARD', selectedCard);
            }
            if (this.model.donationsInfo) {
                this.model.donationsInfo = this.PmtUtilsTransformers.generateDonationsInfo(this.model.donationsInfo, this.model.paymentInfo.currency, this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab]);
                if (foundedDonation && !this.model.donationsInfo[0].available) {
                    this.model.summaryInfo.orderFees.splice(foundedDonationIndex, 1);
                    this.NewMainHeaderFacade.updateBasketOthers('DONATION');
                } else if (!foundedDonation && this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].selectedDonation) {
                    this.model.summaryInfo.orderFees.push({
                        code: 'donation',
                        description: this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].selectedDonation.partner,
                        fee: this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].selectedDonation.option.formatedPrice,
                        totalFee: this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].selectedDonation.option.option
                    });
                    this.NewMainHeaderFacade.updateBasketOthers('DONATION', {
                        code: 'donation',
                        description: this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].selectedDonation.partner,
                        fee: this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].selectedDonation.option.formatedPrice,
                        totalFee: this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].selectedDonation.option.option
                    });
                }
            }
            if (!selectedCard.fee && foundedOtherFee) {
                this.NewMainHeaderFacade.updateBasketOthers('CARD');
                this.model.summaryInfo.orderFees.splice(creditCardFeeIndex, 1);
                this.localStorageService.remove('creditCardFee');

            }
            if (this.model.paymentInfo.appliedDiscounts.status && this.model.paymentInfo.appliedDiscounts.types.AVIOS) {
                if (this.localStorageService.get('creditCardFee')) {
                    if (oldFee) {
                        this.model.paymentInfo.price.totalPrice = this.model.paymentInfo.price.totalPrice - oldFee;
                    }
                    this.model.paymentInfo.price.totalPrice = this.model.paymentInfo.price.totalPrice + selectedCard.totalFee;
                } else {
                    this.model.paymentInfo.price.totalPrice = this.model.paymentInfo.price.totalPrice - oldFee;
                }
            } else {
                this.model.paymentInfo.price.totalPrice = selectedCard.totalToPay ? this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].selectedDonation ? selectedCard.totalToPay + this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].selectedDonation.option.option : selectedCard.totalToPay : this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].total;
                if (this.localStorageService.get('creditCardFee')) {
                    if (oldFee) {
                        this.originalOBPrice = this.originalOBPrice - oldFee;
                    }
                    this.originalOBPrice = this.originalOBPrice + selectedCard.totalFee;
                } else {
                    this.originalOBPrice = this.originalOBPrice - oldFee;
                }
            }
            this.model.paymentInfo.price.formattedTotalPrice = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.price.totalPrice, true);
            this.noDiscountOBPrice = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.originalOBPrice, true);
            this.appliedCCFee = true;
            if (hasBasketDiscountsApplied && headerModelData) {
                headerModelData.headerModel.shoppingBasket.total.totalPrice = this.model.paymentInfo.price.totalPrice;
                headerModelData.headerModel.shoppingBasket.total.formatted = this.model.paymentInfo.price.formattedTotalPrice;
                this.NewMainHeaderFacade.updateHeaderModel(headerModelData);
            }
            this.updateTotalFees();
        }
    }

    /**
     * Get all information about selected quota when service additionalField return variable 'showButtonQuotas' and save in the model
     * @param {*} event Event to activate function
     * @param {*} quotaSelected value quota selected
     */
    getSummaryInfoQuota = (event, quotaSelected) => {
        if (this.model.paymentInfo.selectedPaymentInfo.selectedCard) {
            if (this.model.summaryInfoQuota) {
                delete this.model.summaryInfoQuota;
            }
            this.PmtService.getSummaryInfoQuota(this.$rootScope.serviceURI, quotaSelected, this.model.paymentInfo.paymentId, this.model.paymentInfo.selectedPaymentInfo.selectedCard.cardTypeId, 0).then((infoSummaryQuota) => {
                this.model.summaryInfoQuota = infoSummaryQuota;
            }, angular.noop);
        }
    };
    /**
     * If all param needed from the form call tokenizeCreditCard to save iframe number and cvv
     * @param {*} event Event to activate function
     * @param {*} quotaSelected value quota selected
     */
    getIberiaPayQuotaInfo = (event, quotaSelected) => {
        if ((this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard && this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard.cardTypeId !== 'newCard') || (this.model.paymentInfo.selectedPaymentInfo.selectedCard && this.model.paymentInfo.selectedPaymentInfo.month && this.model.paymentInfo.selectedPaymentInfo.year)) {
            if ((this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === this.PmtConstants.PAYMENT_TYPES.IBERIA_PAY)) {
                this.model.paymentInfo.iberiaPayLoadingIframe = true;
                this.quotaIsLoading = true;
                this.quotaIbPayCall = true;
                this.numberCallEvent = 0;
                this.$window.IBDC.tokenizeCreditCard();
            } else {
                this.$scope.$broadcast('unCheckQuotas');
            }
        } else {
            this.$scope.$broadcast('unCheckQuotas');
        }
    };
    /**
     * When iframe respond with success call this function to obtain available grace months for iberia pay quotas flow
     */
    getIberiaPayQuotaOptions () {
        let result;
        const isSavedCard = this.model.paymentInfo.selectedPaymentInfo && this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard ? this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard.cardTypeId !== 'newCard' : false;
        if (this.model.summaryInfoQuota) {
            delete this.model.summaryInfoQuota;
        }
        if (isSavedCard) {
            const expiryDate = this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard.expiryDate;
            result = expiryDate.slice(2) + expiryDate.slice(0, 2);
        } else {
            const yearStr = String(this.model.paymentInfo.selectedPaymentInfo.year);
            const month = this.model.paymentInfo.selectedPaymentInfo.month;
            result = yearStr.slice(-2) + month.padStart(2, '0');
        }
        this.PmtService.getIberiaPayQuotaOptions(
            this.$rootScope.serviceURI,
            this.model.paymentInfo.paymentId,
            this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].vault.id,
            result,
            isSavedCard ? this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard.cardTypeId : this.model.paymentInfo.selectedPaymentInfo.selectedCard.cardTypeId,
            this.model.paymentInfo.requiredAdditionalFields.info.IBERIA_PAY.QUOTA.value
        ).then((graceMonthOptions) => {
            angular.forEach(this.model.paymentInfo.requiredAdditionalFields.info, (value, key) => {
                if (value.QUOTA) {
                    value.QUOTA.graceMonthOptions = graceMonthOptions;
                    value.QUOTA.graceMonthOptions.items = this.$filter('orderBy')(graceMonthOptions.items, 'deferredMonths');
                    angular.forEach(graceMonthOptions.items, (item, key) => {
                        if (item.deferredMonths === 0) {
                            value.QUOTA.graceMonthDefault = item;
                        }
                    });
                }
            });
            this.model.paymentInfo.iberiaPayLoadingIframe = false;
            this.quotaIsLoading = false;
            this.$scope.$broadcast('selectDefaultDeferedMonth');
        }, (error) => {
            const hasReason = error.data && error.data.errors && error.data.errors.length > 0, emptyError = !!(hasReason && error.data.errors[0].code === 'PMT_PPM_13100'),
                modalObject = {
                    title: 'MODAL_ERROR_TITLE',
                    message: hasReason ? error.data.errors[0].reason : error.data && error.data.error ? error.data.error.reason : this.$filter('translate')(this.PmtConstants.GENERAL_ERRORS.SERVICE_GENERAL_ERROR),
                    needsTranslate: !hasReason,
                    showbuttons: {
                        accept: {
                            status: true,
                            text: 'MODAL_CANCEL_BUTTON',
                            accessibleText: 'MODAL_CANCEL_BUTTON'

                        }
                    }
                }, graceMonthOptions = {
                    items: [
                        {
                            deferredMonths: 0,
                            errorCode: error.data.errors[0].code,
                            deferredQuotaAmount: {
                                total: ''
                            },
                            interest: 0,
                            totalAmount: {
                                total: ''
                            }
                        }
                    ]
                };
            if (emptyError) {
                angular.forEach(this.model.paymentInfo.requiredAdditionalFields.info, (value, key) => {
                    if (value.QUOTA) {
                        value.QUOTA.graceMonthOptions = graceMonthOptions;
                        value.QUOTA.graceMonthDefault = graceMonthOptions.items[0];
                    }
                });
                this.model.paymentInfo.iberiaPayLoadingIframe = false;
                this.quotaIsLoading = false;
                this.$scope.$broadcast('selectDefaultDeferedMonth');
            } else {
                this.PmtModalService.showGenericError(modalObject, true, this.PmtConstants.MODALS.GENERIC_ERROR_MODAL_PAYMENT).result.then(() => {
                    this.$scope.$broadcast('unCheckQuotas');
                    this.model.paymentInfo.iberiaPayLoadingIframe = false;
                    this.quotaIsLoading = false;
                }, () => {
                    this.$scope.$broadcast('unCheckQuotas');
                    this.model.paymentInfo.iberiaPayLoadingIframe = false;
                    this.quotaIsLoading = false;
                });
            }

        });

    }
    getSummaryInfoQuotaDeferedMonth = (event, deferedMonthSelected, quotaSelected) => {
        let summaryInfoQuota;
        if (deferedMonthSelected && !deferedMonthSelected.errorCode) {
            summaryInfoQuota = {
                quotaPrice: { fare: deferedMonthSelected.deferredQuotaAmount.total },
                interest: { percentage: deferedMonthSelected.interest + '' },
                totalPrice: { total: this.model.paymentInfo.paymentMethods[0].total, currency: deferedMonthSelected.totalAmount.currency },
                finalPrice: { fare: deferedMonthSelected.totalAmount.total },
                quotasQuantity: quotaSelected,
                deferredMonths: deferedMonthSelected.deferredMonths
            };
        } else if (deferedMonthSelected && deferedMonthSelected.errorCode) {
            this.model.deferredMonthsError = true;
        }
        if (this.model.summaryInfoQuota) {
            delete this.model.summaryInfoQuota;
        }
        this.model.summaryInfoQuota = summaryInfoQuota;
    };
    /**
     * Open modal summary-info-quotas with all details about selected quota
     * @param {event} openModalInfoQuota Event to activate function
     */
    openModalInfoQuota = (event) => {
        const model = this.model.summaryInfoQuota;
        angular.extend(model, { idModal: '' });
        this.PmtModalService.showGenericModal(false, 'ib-modal-summary-info-quota.html', model).result.then(angular.noop, angular.noop);
    };
    /**
     * Open Modal general-info-quotas with general information about quotas
     * @param {Event} showGeneralModalInfoQuota Event to activate function
     */
    openGeneralModalInfoQuotas = (event) => {
        const typesCreditCards = this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].types;
        this.PmtModalService.showGenericModal(false, 'ib-modal-general-info-quotas.html', typesCreditCards).result.then(angular.noop, angular.noop);
    };
    adyenComponent = (event, serviceData) => {
        let configuration, div, config3ds2Window, componentData, challengeModal;
        this.CommonsKeepAliveUtilsService.keepSessionAlive();
        this.loadingIframeForm = true;
        this.model.paymentInfo.componentInfoAdyen = {};
        this.model.paymentInfo.componentInfoAdyen.type = serviceData.component.type;
        const handleOnAdditionalDetails = (state) => {
            this.model.paymentInfo.componentInfoAdyen.data = state.data.details['threeds2.fingerprint'] ? state.data.details['threeds2.fingerprint'] : state.data.details['threeds2.challengeResult'] ? state.data.details['threeds2.challengeResult'] : null;
            if (state.data.details['threeds2.challengeResult'] && challengeModal) {
                challengeModal.close();
            }
            this.$timeout(() => {
                this.submitPayment(null, '3ds2Adyen');
            });
        };
        configuration = {
            locale: this.PmtUtilsService.getLanguagePaypal(),
            environment: this.$rootScope.production ? 'live' : 'test',
            clientKey: this.$rootScope.production ? this.PmtConstants.ADYEN_CLIENT_KEY.production : this.PmtConstants.ADYEN_CLIENT_KEY.test,
            onAdditionalDetails: handleOnAdditionalDetails
        };
        this.adyenCheckout = new AdyenCheckout(configuration);
        switch (serviceData.component.type) {
                case 'REDIRECT':
                    div = '<div id="pmt-adyen-redirect" class="sr-only"></div>';
                    angular.element(this.$document).find('body').append(this.$compile(div)(this.$rootScope));
                    serviceData.component.data = {
                        MD: serviceData.component.providerData.md,
                        PaReq: serviceData.component.providerData.paReq,
                        TermUrl: serviceData.component.providerData.termUrl
                    };
                    serviceData.component.type = serviceData.component.authenticationType;
                    delete serviceData.component.providerData;
                    delete serviceData.component.authenticationType;
                    this.localStorageService.set('redirectionPaymentCallback', { status: true, redirectStatus: false, data: this.model, syncPayment: true });
                    this.adyenCheckout.createFromAction(serviceData.component).mount('#pmt-adyen-redirect');
                    break;
                case 'FINGERPRINT':
                    angular.element(this.$document[0].getElementById('pmt-adyen-finger-print')).remove();
                    angular.element(this.$document[0].getElementsByClassName('adyen-checkout-risk__device-fingerprint--wrapper')).remove();
                    div = '<div id="pmt-adyen-finger-print" class="sr-only"></div>';
                    angular.element(this.$document).find('body').append(this.$compile(div)(this.$rootScope));
                    serviceData.component.type = serviceData.component.authenticationType;
                    delete serviceData.component.authenticationType;
                    this.adyenCheckout.createFromAction(serviceData.component).mount('#pmt-adyen-finger-print');
                    break;
                case 'CHALLENGE':
                    this.PmtModalService.finishWaiting();
                    challengeModal = this.PmtModalService.showGenericModal(true, 'ib-modal-payment-3ds2.html', {}, 'ib-modals--adyen');
                    challengeModal.result.then(angular.noop, () => {
                        this.model.paymentInfo.componentInfoAdyen.data = 'eyJ0cmFuc1N0YXR1cyI6Ik4ifQ==';
                        this.submitPayment(null, '3ds2Adyen');
                    });
                    config3ds2Window = { size: this.$window.innerWidth >= 560 ? '03' : '01' };
                    serviceData.component.type = serviceData.component.authenticationType;
                    delete serviceData.component.authenticationType;
                    componentData = serviceData.component;
                    this.$timeout(() => {
                        this.adyenCheckout.createFromAction(componentData, config3ds2Window).mount('#pmt-adyen-3ds2-component');
                    });
                    break;
                default:
                    break;
        }
    };
    oneSiteIframe = (event, formData) => {
        this.loadingIframeForm = true;
        this.PmtModalService.finishWaiting();
        const isComponent = formData?.component?.url;
        const redirectURL = isComponent ? formData.component.url : formData.redirectURL;
        const redirectionPaymentCallback: any = { status: true, redirectStatus: false, data: this.model };
        if(isComponent) { // is redirect component
            redirectionPaymentCallback.oneSiteSync = true;
            redirectionPaymentCallback.syncPayment = true;
        } else {
            redirectionPaymentCallback.oneSiteIframe = true;
        }
        this.localStorageService.set('redirectionPaymentCallback', redirectionPaymentCallback);
        this.PmtModalService.showGenericModal(false, 'ib-modal-payment-3ds2.html', { iframeUrl: this.$sce.trustAsResourceUrl(redirectURL) }, 'ib-modals--desktop ib-modals--reset').result.then(angular.noop, angular.noop);
    };
    /**
     * Manage the 3DS Event to generate form and redirect to external page
     * @param {Even} generate3DSFORM Event to lunch function
     * @param {Object} formData All information necesary to generate form , this info is  return by service issue when code error is 451
     */
    externalPayForm = (event, formData) => {
        const isComponent = formData?.component?.url;
        const redirectURL = isComponent ? formData.component.url : formData.redirectURL;
        const formId = formData.redirectData && formData.redirectData.hash ? formData.redirectData.hash : redirectURL.match('[?&]transactionId=([^&]+).*$') ? redirectURL.match('[?&]transactionId=([^&]+).*$')[1] : redirectURL.match('[?&]authReference=([^&]+).*$') ? redirectURL.match('[?&]authReference=([^&]+).*$')[1] : (Math.random().toString(36) + '00000000000000000').slice(2, 18);
        let form = '<form id = "' + formId + '" action="' + this.$sce.trustAsResourceUrl(redirectURL) + '" method="post">';
        this.loadingIframeForm = true;
        if (formData.component && formData.component.type && formData.provider !== 'ONESAIT') {
            this.model.paymentInfo.componentInfoAdyen = {};
            this.model.paymentInfo.componentInfoAdyen.type = formData.component.type;
        }
        if(formData.provider === 'IATA_PAY'){
            this.localStorageService.set('redirectionPaymentCallback', { status: true, redirectStatus: false, data: this.model });
            this.$window.location.href = formData.redirectURL;
        }else if (formData.component && formData.component.type === 'IDEAL') {
            this.localStorageService.set('redirectionPaymentCallback', { status: true, redirectStatus: false, data: this.model });
            this.$window.location.href = formData.redirectURL;
        } else if (angular.element(this.$document).find('#' + formId).length === 0) {
            const redirectionPaymentCallback: any = { status: true, redirectStatus: false, data: this.model };
            if(isComponent) { // is redirect component
                redirectionPaymentCallback.syncPayment = true;
                if(formData.provider === 'ONESAIT') {
                    redirectionPaymentCallback.oneSiteSync = true;
                }
            }
            this.localStorageService.set('redirectionPaymentCallback', redirectionPaymentCallback);
            angular.forEach(formData.redirectData, (inputInfo, inputName) => {
                form += '<input type="hidden" name="' + inputName + '" value="' + inputInfo + '" />';
            });
            form += '<input type="submit" id="submit_hidden_form" class="u-hide" /></form>';
            angular.element(this.$document).find('body').append(this.$compile(form)(this.$rootScope));
            this.$timeout(() => {
                angular.element(angular.element(this.$document).find('#' + formId).find('#submit_hidden_form')).trigger('click');
            });
        }
    };


    /**
     * Generate form into modal to pay in LATAM markets
     * @param {Even} generate3DSIFRAME Event to lunch function
     * @param {Object} formData All information necesary to generate external form , this info is  return by service issue when code error is 451
     */
    generateIframeForm = (event, formData) => {
        let form = '<form id="iframeForm" action="' + this.$sce.trustAsResourceUrl(formData.redirectURL) + '" method="post" target="iframeExternalPayment">';
        this.localStorageService.set('redirectionPaymentCallback', { status: true, redirectStatus: false, data: this.model });
        angular.forEach(formData.redirectData, (inputInfo, inputName) => {
            form += '<input type="hidden" name="' + inputName + '" value="' + inputInfo + '" />';
        });

        form += '<input type="submit" id="submit_hidden_form" class="u-hide" /></form>';
        this.$rootScope.$broadcast('endLoadingPlaneEvent');
        this.PmtModalService.finishWaiting();
        this.$timeout(() => {
            this.PmtModalService.showGenericModal(false, 'external-payment-modal.html', { title: 'IBPURC_EXTERNAL_PAYMENT_IFRAME_BANKING_SELECT_BANK_TITLE', subtitle: 'IBPURC_EXTERNAL_PAYMENT_IFRAME_BANKING_SELECT_BANK_SUBTITLE', accept: 'PAYMENT_BUTTON_MODAL_EXTERNAL' }).result.then(angular.noop, angular.noop);
        });
        this.$timeout(() => {
            angular.element(this.$document).find('#externalPaymentModal').append(this.$compile(form)(this.$scope));
            angular.element(this.$document).find('#iframeForm').submit();
        });
    };

    /**
     *Generates a forms when the payment method is 'button'. The form is generated, depending on the type of provider.
     * @param {Event} generateExtenalButtonForm event to lunch function
     * @param {Object} formData All information necesary to generate external form , this info is  return by service issue when code error is 451
     */
    generateExternalButtonForm = (event, formData) => {
        /**
         * Generate form for payment method Button when provider is DOCOMO_IDEAL
         * @param {Object} formData All information necesary to generate external form , this info is  return by service issue when code error is 451
         */
        const generateOnlineBankingIdealForm = (formData) => {
            let script, form, selectBanks, banksSelectOptionsIndex, banksSelectOptions = [];
            this.localStorageService.set('redirectionPaymentCallback', { status: true, redirectStatus: false, data: this.model });
            this.$window.wpwlOptions = {
                locale: this.$rootScope.appLang,
                onReady: () => {
                    this.$rootScope.$broadcast('endLoadingPlaneEvent');
                    this.PmtModalService.finishWaiting();
                    this.$timeout(() => {
                        angular.element(this.$document).find('.spinner').css('display', 'none');
                        angular.element(this.$document).find('.wpwl-container').css('display', 'none');
                        selectBanks = angular.element(this.$document).find('select[name="bankAccount.bankName"]')[0];
                        for (banksSelectOptionsIndex = 0; banksSelectOptionsIndex < selectBanks.length; banksSelectOptionsIndex++) {
                            banksSelectOptions.push(
                                {
                                    id: banksSelectOptionsIndex,
                                    bankName: selectBanks[banksSelectOptionsIndex].text,
                                    bankValue: selectBanks[banksSelectOptionsIndex].value
                                }
                            );
                        }
                        angular.extend(this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab], { banksSelectOptions: banksSelectOptions });
                        this.PmtModalService.showGenericModal(false, 'online-banking-select-modal.html', { title: 'IBPURC_PAYMENTS_ONLINE_BANKING_SELECT_BANK_TITLE', subtitle: 'IBPURC_PAYMENTS_ONLINE_BANKING_SELECT_BANK_SUBTITLE', accept: 'PAYMENT_BUTTON_MODAL_EXTERNAL', banksSelectOptions: banksSelectOptions }).result.then((selectedBankOption) => {
                            if (this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === this.PmtConstants.PAYMENT_TYPES.BUTTON && this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].provider === this.PmtConstants.PAYMENTS_PROVIDER.IDEAL && selectedBankOption) {
                                angular.element(this.$document).find('.wpwl-control-bankName').find('option').remove().end();
                                angular.element(this.$document).find('select[name="bankAccount.bankName"]').append('<option selected=\"selected\" value="' + selectedBankOption.bankValue + '"></option>');
                                angular.element(this.$document).find('.wpwl-form').submit();
                                this.PmtModalService.showWaitingModal('ib-modal-pmt-cards', 'ib-modals ib-modals--transparent', true, { transition: 'SOFORT' });
                            }
                        }, angular.noop);
                    });
                }
            };
            form = '<form action="' + this.$sce.trustAsResourceUrl(formData.paymentFormURL) + '" class="paymentWidgets" data-brands="' + formData.paymentFormDataAttributes['data-brands'] + '" </form>';
            this.$timeout(() => {
                angular.element(this.$document).find('#onlineBankingForm').append(this.$compile(form)(this.$scope));
            });
            script = '<script src="' + formData.resourceJavaScriptURL + '"></script>';
            this.$timeout(() => {
                angular.element(this.$document).find('#onlineBankingForm').append(this.$compile(script)(this.$scope));
            });
        };

        /**
         * Generate form for payment method EXTERNAL_CREDICARD when provider is JCB
         * @param {Object} formData All information necesary to generate external form , this info is  return by service issue when code error is 451
         */
        const generateJcbForm = (formData) => {
            let script, form, banksSelectOptions = [], foundElement = angular.element(this.$document).find('#externalPayment').length > 0;
            this.localStorageService.set('redirectionPaymentCallback', { status: true, redirectStatus: false, data: this.model });
            this.$window.wpwlOptions = {
                locale: this.$rootScope.appLang,
                onReady: () => {
                    this.$rootScope.$broadcast('endLoadingPlaneEvent');
                    this.PmtModalService.finishWaiting();
                    this.$timeout(() => {
                        angular.element(this.$document).find('.spinner').css('display', 'none');
                        angular.element(this.$document).find('.wpwl-container').css('display', 'none');
                        angular.extend(this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab], { banksSelectOptions: banksSelectOptions });
                        this.PmtModalService.showGenericModal(false, 'external-payment-modal.html', { title: 'IBPURC_EXTERNAL_PAYMENT_IFRAME_BANKING_SELECT_BANK_TITLE', subtitle: 'IBPURC_EXTERNAL_PAYMENT_IFRAME_BANKING_SELECT_BANK_SUBTITLE', accept: 'PAYMENT_BUTTON_MODAL_EXTERNAL' }).result.then((selectedankOption) => {
                            angular.element(this.$document).find('.wpwl-form').submit();
                            event.preventDefault();
                        }, angular.noop);
                        this.$timeout(() => {
                            angular.element(this.$document).find('#iframeExternalPayment').remove();
                            angular.element(this.$document).find('#externalPayment').removeClass('u-hide');
                            angular.element(this.$document).find('.wpwl-form').removeClass('wpwl-form-card');
                            angular.element(this.$document).find('.wpwl-group-brand').css({ display: 'none' });
                            angular.element(this.$document).find('.wpwl-label').css({ 'font-weight': 'bold' });
                            angular.element(this.$document).find('.wpwl-group').css({ width: '100%', 'padding-right': '0px', 'font-family': 'iberiaheadline' });
                            angular.element(this.$document).find('.wpwl-button.wpwl-button-pay').addClass('ib-button ib-button--w-medium');
                            angular.element(this.$document).find('.wpwl-button.wpwl-button-pay').removeClass('wpwl-button wpwl-button-pay');
                            angular.element(this.$document).find('#externalPaymentModal').append(angular.element(this.$document).find('#externalPayment'));
                        });
                        this.$timeout(() => {
                            angular.element(this.$document).find('.wpwl-container').css('display', '');
                        }, 2000);
                    });
                }
            };
            form = '<form action="' + this.$sce.trustAsResourceUrl(formData.paymentFormURL) + '" class="paymentWidgets" data-brands="' + formData.paymentFormDataAttributes['data-brands'] + '" </form>';
            this.$timeout(() => {
                if (!foundElement) {
                    angular.element(this.$document).find('body').append('<div id="externalPayment" class="u-hide"></div>');
                }
                angular.element(this.$document).find('#externalPayment').append(this.$compile(form)(this.$scope));
            });
            script = '<script src="' + formData.resourceJavaScriptURL + '"></script>';
            this.$timeout(() => {
                angular.element(this.$document).find('#externalPayment').append(this.$compile(script)(this.$scope));
                angular.element(this.$document).find('.spinner').css('display', 'none');
            });
        };


        /**
         * Generate form for payment method BUTTON  when provider is different to DOCOMO_IDEAL or JCB (UNIONPAY, ALIPAY, WECHAT , SOFORT).
         * @param {Object} formData All information necesary to generate external form , this info is  return by service issue when code error is 451
         */
        const generateOnlineBankingForm = (formData) => {
            const form = '<form action="' + this.$sce.trustAsResourceUrl(formData.paymentFormURL) + '" class="paymentWidgets u-hide" data-brands="' + formData.paymentFormDataAttributes['data-brands'] + '" </form>';
            const script = '<script src="' + formData.resourceJavaScriptURL + '"></script>';
            this.loadingOnlineBankingForm = true;
            this.localStorageService.set('redirectionPaymentCallback', { status: true, redirectStatus: false, data: this.model });
            angular.element(this.$document).find('body').append(this.$compile(form)(this.$scope));
            this.$window.wpwlOptions = {
                locale: this.$rootScope.appLang,
                onReady: () => {
                    angular.element(this.$document).find('.spinner').css('display', 'none');
                    angular.element(this.$document).find('.wpwl-container').css('display', 'none');
                    angular.element(this.$document).find('.wpwl-control-country').find('option').remove().end();
                    angular.element(this.$document).find('select[name="bankAccount.country"]').append('<option selected=\"selected\" value="' + this.dataRequest.issueCountry + '"></option>');
                    angular.element(this.$document).find('.wpwl-form').submit();
                }
            };
            this.$timeout(() => {
                angular.element(this.$document).find('body').append(this.$compile(script)(this.$scope));
            });
        };


        if (this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === this.PmtConstants.PAYMENT_TYPES.BUTTON && this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].provider === this.PmtConstants.PAYMENTS_PROVIDER.IDEAL) {
            generateOnlineBankingIdealForm(formData);
        } else if (this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type === this.PmtConstants.PAYMENT_TYPES.EXTERNAL_CREDITCARD && this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].cardTypeCode === this.PmtConstants.PAYMENTS_PROVIDER.JCB) {
            generateJcbForm(formData);
        } else {
            generateOnlineBankingForm(formData);
        }
    };




    /**
     * Delete data on model
     * @param {BOOL} isComplete If pay is complete, clean loggedCard.
     */
    deletePrivateData = (isComplete?) => {
        if (this.model.selectedLoggedCard && this.model.selectedLoggedCard.paymentInfo.cardTypeId !== 'newCard') {
            delete this.model.paymentInfo.selectedCard;
        }
        delete this.model.paymentInfo.selectedPaymentInfo.cardNumber;
        delete this.model.paymentInfo.selectedPaymentInfo.newCvv;
        delete this.model.paymentInfo.selectedPaymentInfo.month;
        delete this.model.paymentInfo.selectedPaymentInfo.year;
        delete this.model.paymentInfo.selectedPaymentInfo.selectedCard;
        delete this.model.paymentInfo.selectedPaymentInfo.zipCode;
        if (isComplete) {
            delete this.model.selectedLoggedCard;
        }
    };

    /**
     * Change the country for the selected card and update the payment methods
     * @param {Event} event
     * @param {Object} issuerCountry object with all information about country
     * @param {Object} selectedCard object with all information selected if user is logged
     * @param {Object} creditCardFormModel is the model credit card
     */
    changeIssuerCountry = (event, issuerCountry, selectedCard, creditCardFormModel) => {
        this.model.showOptions.showLoadingData = true;
        this.NewMainHeaderFacade.updateBasketOthers('CARD');
        this.localStorageService.set('selectedIssuerCountry', issuerCountry);
        this.localStorageService.set('changeCountryInCombo', true);
        this.localStorageService.set('selectedPaymentMethod', { type: this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].type, provider: this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].provider });
        if (this.localStorageService.get('creditCardFee')) {
            this.localStorageService.remove('creditCardFee');
        }
        this.PmtService.getPaymenMethodsInfo(this.dataRequest.ident, issuerCountry.code, this.$rootScope.serviceURI, true).then((data) => {
            this.model = data;
            this.updatePayments(issuerCountry, this.model.paymentInfo.customerCreditCards, selectedCard, creditCardFormModel);
        }, (error) => {
            this.model.showOptions.showLoadingData = false;
        });
    };



    /**
     * Update all information about model payments.
     * @param {Object} issuerCountry Country for make request to service
     * @param {Array<Object>} customerCards Customer cards of user returned of service
     * @param {Object} selectedCard Information credit card selected if user logged, if the user not select creditcard, asign general form
     * @param {Object} creditCardFormModel all information credit card  form
     */
    updatePayments = (issuerCountry, customerCards, selectedCard, creditCardFormModel) => {
        const donationData = this.localStorageService.get('donation');
        this.model.generalData.issuerCountry = issuerCountry;
        if (this.localStorageService.get('userLogged')) {
            if (selectedCard) {
                this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard = this.getSelectedLoggedCard(selectedCard, customerCards, issuerCountry, creditCardFormModel);
            } else {
                this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard = {
                    description: 'CREDIT_CARD_FORM_SELECT_NEW_LOGGED_OPTION',
                    cardTypeId: 'newCard',
                    profileCardId: 'newCard',
                    active: true,
                    provider: {
                        CREDITCARD: true,
                        IBERIA_PAY: true
                    }
                };
            }
            if ((this.model.paymentInfo.paymentMethods[0].type !== 'IBERIA_PAY' && this.model.paymentInfo.paymentMethods[0].type !== 'ONHOLD_IBERIA_PAY') || (this.model.paymentInfo.customerCreditCards.IBERIA_PAY && this.model.paymentInfo.customerCreditCards.IBERIA_PAY.length > 1) || (this.model.paymentInfo.customerCreditCards.ONHOLD_IBERIA_PAY && this.model.paymentInfo.customerCreditCards.ONHOLD_IBERIA_PAY.length > 1)) {
                this.model.paymentInfo.iberiaPayLoadingIframe = false;
            }
        }
        this.updateFee(this.model.paymentInfo.selectedPaymentInfo.selectedLoggedCard);
        if (donationData) {
            this.checkDonation('event', true, donationData.option, donationData.donationInfo, donationData.form ? donationData.form.acceptDonationData : null, donationData.form ? donationData.form : null);
        }
        this.$timeout(() => {
            this.model.selectedData.selectedTab = this.getActivateSelectedTab(this.localStorageService.get('selectedPaymentMethod'), this.model.paymentInfo.paymentMethods);
            this.$scope.$broadcast('updateSelectedTabEvent', this.model.selectedData.selectedTab);
            if (this.flowApp === this.PmtConstants.APP_TYPES.ONHOLD) {
                this.model.selectedData.selectedOnHoldIndex = this.localStorageService.get('onHoldOptionSelected') ? this.localStorageService.get('onHoldOptionSelected') : 0;
                this.changeSelectedHoldOption(null, this.model.paymentInfo.onHoldInfo.onHoldPaymentOptions[this.model.selectedData.selectedOnHoldIndex], this.model.selectedData.selectedOnHoldIndex);
            }
            this.model.showOptions.showLoadingData = false;
            angular.element(this.$window).triggerHandler('resize');
        });
    };

    /**
     * Return a Object with all information about credit card selected by user, to update model info
     * @param {Object} selectedLoggedCard Object with all credit card information
     * @param {Array<Object>} customerCreditCards Array with all customer credit card info user
     * @param {Object} issuerCountry Object with information about issuer country
     */
    getSelectedLoggedCard = (selectedLoggedCard, customerCreditCards, issuerCountry, creditCardFormModel) => {
        let returnedSelectedLoggedCard = null, foundedCustomerCard = false, foundedCustomerCardIndex = 0;
        if (selectedLoggedCard && customerCreditCards) {
            while (!foundedCustomerCard && foundedCustomerCardIndex < customerCreditCards[creditCardFormModel.type].length) {
                if (customerCreditCards[creditCardFormModel.type][foundedCustomerCardIndex].active && customerCreditCards[creditCardFormModel.type][foundedCustomerCardIndex].profileCardId === selectedLoggedCard.profileCardId) {
                    if (customerCreditCards[creditCardFormModel.type][foundedCustomerCardIndex].profileCardId !== 'newCard' && !customerCreditCards[creditCardFormModel.type][foundedCustomerCardIndex].profileAddressInfo.country) {
                        customerCreditCards[creditCardFormModel.type][foundedCustomerCardIndex].profileAddressInfo.country = issuerCountry;
                    }
                    returnedSelectedLoggedCard = customerCreditCards[creditCardFormModel.type][foundedCustomerCardIndex];
                    foundedCustomerCard = true;
                }
                foundedCustomerCardIndex++;
            }
        }
        return returnedSelectedLoggedCard;
    };

    /**
     *
     * @param {*} previousSelectedPaymentMethod
     * @param {*} actualPaymentMehods
     */
    getActivateSelectedTab = (previousSelectedPaymentMethod, actualPaymentMehods) => {
        let returnedSelectedTab = 0, foundedPaymentMethod = false, paymentMethodIndex = 0;
        if (previousSelectedPaymentMethod && actualPaymentMehods) {
            while (!foundedPaymentMethod && paymentMethodIndex < actualPaymentMehods.length) {
                if ((actualPaymentMehods[paymentMethodIndex].type === previousSelectedPaymentMethod.type) && (!previousSelectedPaymentMethod.provider || previousSelectedPaymentMethod.provider === actualPaymentMehods[paymentMethodIndex].provider)) {
                    returnedSelectedTab = paymentMethodIndex;
                    foundedPaymentMethod = true;
                }
                paymentMethodIndex++;
            }
        }
        return returnedSelectedTab;
    };

    /**
     * Update tab if the user change payment method
     * @param {*} event
     * @param {*} indexTab index tab
     */
    changeSelectedTab = (event, indexTab, previousActiveTab) => {
        let i, j, donationData = this.localStorageService.get('donation'), ccFeeIndex = 0,
            oldFee = this.localStorageService.get('creditCardFee') ? this.localStorageService.get('creditCardFee').totalFee : null,
            isLogged = this.localStorageService.get('userLogged');
        this.model.paymentInfo.selectedPaymentInfo = {};
        if (this.model.paymentInfo.paymentMethods[indexTab].type === 'PAYPAL') {
            this.model.showOptions.showRegularButton = false;
        } else {
            this.model.showOptions.showRegularButton = true;
        }

        if (this.model.paymentInfo.paymentMethods[indexTab].type === 'IBERIA_PAY') {
            if (isLogged) {
                if (this.model.paymentInfo.customerCreditCards.IBERIA_PAY.length <= 1) {
                    this.model.paymentInfo.iberiaPayLoadingIframe = true;
                } else {
                    this.model.paymentInfo.iberiaPayLoadingIframe = false;
                }
            } else if (previousActiveTab !== indexTab) {
                this.model.paymentInfo.iberiaPayLoadingIframe = true;
            }
        } else {
            this.model.paymentInfo.iberiaPayLoadingIframe = false;
        }

        if (this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].provider === 'MERCADO_PAGO') {
            this.ibPmtMercadoPagoService.setMercadoPagoAvailable(false);
            this.mercadoPagoIsCalled = false;
        }

        if (this.model.paymentInfo.paymentMethods[indexTab].type === 'PAYPAL' || this.model.paymentInfo.paymentMethods[indexTab].type === 'BUTTON') {
            if (this.model.summaryInfo.orderFees) {
                for (i = 0; i < this.model.summaryInfo.orderFees; i++) {
                    if (this.model.summaryInfo.orderFees[i].code === 'creditCardFee') {
                        ccFeeIndex = i;
                    }
                }
                if (oldFee !== null && this.appliedCCFee) {
                    this.NewMainHeaderFacade.updateBasketOthers('CARD');
                    this.NewMainHeaderFacade.updateBasketOthers('DONATION');
                    this.model.paymentInfo.price.totalPrice -= oldFee;
                }
                this.appliedCCFee = false;
                this.model.paymentInfo.price.formattedTotalPrice = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.price.totalPrice, true);
                this.model.summaryInfo.orderFees.splice(ccFeeIndex, 1);
            }
        } else {
            this.localStorageService.get('creditCardFee') && this.model.summaryInfo.orderFees.length <= 0 ? (this.model.summaryInfo.orderFees.push(this.localStorageService.get('creditCardFee')),
            this.updateFee(this.localStorageService.get('typeCardSelected'))) : angular.noop;
        }

        if (this.model.donationsInfo) {
            for (i = 0; i < this.model.donationsInfo.length; i++) {
                this.model.donationsInfo[i].available = false;
                for (j = 0; j < this.model.donationsInfo[i].possibilities.length; j++) {
                    if (this.model.paymentInfo.paymentMethods[indexTab].type === this.model.donationsInfo[i].possibilities[j].type) {
                        this.model.donationsInfo[i].available = true;
                    }
                }
                if (donationData && this.model.donationsInfo[i].available === false) {
                    this.checkDonation('event', false, donationData.option, donationData.donationInfo, donationData.form ? donationData.form.acceptDonationData : null, donationData.form ? donationData.form : null);
                    this.NewMainHeaderFacade.updateBasketOthers('DONATION');
                    this.localStorageService.set('donation', donationData);
                } else if (donationData) {
                    this.checkDonation('event', true, donationData.option, donationData.donationInfo, donationData.form ? donationData.form.acceptDonationData : null, donationData.form ? donationData.form : null);
                }
            }
        }
        this.model.selectedData.selectedTab = indexTab;
        this.DccService.setDccData();
    };

    /**
     *  Update payment methods when user check voucher or change countryIssue
     * @param {Event} updatePaymenthMethodsInfo Event to lunch function
     */
    updatePaymenthMethodsInfo = (event) => {
        let errorVoucher = this.model.paymentInfo.appliedDiscounts.error;
        let issueCountry = this.localStorageService.get('selectedIssuerCountry') ? this.localStorageService.get('selectedIssuerCountry').code : this.model.generalData.issuerCountry.code,
            donationData = this.localStorageService.get('donation'), createOrderData: any = {}, hasBasketDiscountsApplied = false, headerModelData: any = {}, discountsAppliedAux = {};
        this.model.showOptions.loadingPaymentData = true;
        createOrderData = this.localStorageService.get('createOrderData');
        if (createOrderData && createOrderData.order && createOrderData.order.discountsApplied && createOrderData.order.discountsApplied.discounts && createOrderData.order.discountsApplied.discounts.length > 0) {
            hasBasketDiscountsApplied = true;
        }
        this.PmtService.getPaymenMethodsInfo(this.dataRequest.ident, issueCountry, this.$rootScope.serviceURI).then((data) => {
            this.getCcFeeRequest(data.paymentInfo?.price.totalPrice, data.paymentInfo?.currency, this.dataRequest?.issueCountry, data.summaryInfo?.trips);
            this.DccService.setDccData();
            const selectAviosDisscount = this.localStorageService.get('selectedAviosDisccount');
            let existentOtherCardFee = false;
            const previousAncillaries = this?.model?.summaryInfo?.ancillaries;
            this.model = data;
            this.localStorageService.set('modelPaymentData', data);
            this.model.selectedData.selectedTab = this.getActivateSelectedTab(this.localStorageService.get('selectedPaymentMethod'), this.model.paymentInfo.paymentMethods);
            this.$scope.$broadcast('updateSelectedTabEvent', this.model.selectedData.selectedTab);
            angular.element(this.$window).triggerHandler('resize');
            headerModelData = this.localStorageService.get('headerModel');
            this.selectedData = this.localStorageService.get('selectedPaymentData') ? this.localStorageService.get('selectedPaymentData') : this.selectedData ? this.selectedData : {};
            if (!(this.selectedData && this.selectedData.selectedAviosIndex && selectAviosDisscount &&
                this.model.paymentInfo.paymentMethods[0].type !== this.PmtConstants.DISCOUNT_TYPES.VOUCHER &&
                (this.model.paymentInfo.availableDiscounts[this.PmtConstants.DISCOUNT_TYPES.AVIOS] && this.model.paymentInfo.availableDiscounts[this.PmtConstants.DISCOUNT_TYPES.AVIOS].disscounts.length >= this.selectedData.selectedAviosIndex))
                || !(this.model.paymentInfo.appliedDiscounts && this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER])
                || !(this.model.paymentInfo.appliedDiscounts && this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.AVIOS] && !this.model.paymentInfo.availableDiscounts[this.PmtConstants.DISCOUNT_TYPES.AVIOS].available)) {
                // recoger descuento y llamar a sumary

                this.NewMainHeaderFacade.updateBasketDiscounts();
                this.$scope.$broadcast('selectInitialAviosIndex', true);
            }
            this.model.paymentInfo.appliedDiscounts.error  =errorVoucher;
            if (this.selectedData && this.selectedData.selectedAviosIndex &&
                selectAviosDisscount && this.model.paymentInfo.paymentMethods[0].type !== this.PmtConstants.DISCOUNT_TYPES.VOUCHER &&
                this.model.paymentInfo.availableDiscounts && this.model.paymentInfo.availableDiscounts[this.PmtConstants.DISCOUNT_TYPES.AVIOS] && this.model.paymentInfo.availableDiscounts[this.PmtConstants.DISCOUNT_TYPES.AVIOS].available &&
                (this.model.paymentInfo.availableDiscounts[this.PmtConstants.DISCOUNT_TYPES.AVIOS] && this.model.paymentInfo.availableDiscounts[this.PmtConstants.DISCOUNT_TYPES.AVIOS].disscounts.length >= this.selectedData.selectedAviosIndex)) {
                this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.AVIOS] = {
                    formatedAvios: this.CurrencyService.formatAvios(this.model.paymentInfo.currency.groupingSeparator, selectAviosDisscount.aviosRequired).trim(),
                    type: this.PmtConstants.DISCOUNT_TYPES.AVIOS,
                    id: selectAviosDisscount.aviosRequired,
                    discount: this.CurrencyService.formatPrice(this.model.paymentInfo.currency, selectAviosDisscount.totalDiscount.fare, true),
                    originalDiscount: selectAviosDisscount.totalDiscount.fare
                };
                this.NewMainHeaderFacade.updateBasketDiscounts(this.PmtConstants.DISCOUNT_TYPES.AVIOS, this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.AVIOS]);
                this.$scope.$broadcast('selectInitialAviosIndex', false);
            }
            if (this.model && this.model.summaryInfo && this.model.summaryInfo.orderFees && this.model.summaryInfo.orderFees[0] && headerModelData.headerModel.shoppingBasket.othersModel.others) {
                if (headerModelData.headerModel.shoppingBasket.othersModel.others && headerModelData.headerModel.shoppingBasket.othersModel.others.length > 0) {
                    angular.forEach(headerModelData.headerModel.shoppingBasket.othersModel.others, (otherFee) => {
                        if (otherFee.code === this.PmtConstants.ORDER_ITEMS_TYPES.CREDIT_CARD_FEE && otherFee.code === this.model.summaryInfo.orderFees[0].code) {
                            existentOtherCardFee = true;
                        }
                    });
                }
                if (!existentOtherCardFee) {
                    this.NewMainHeaderFacade.updateBasketOthers(this.model.summaryInfo.orderFees[0].description, {
                        code: this.model.summaryInfo.orderFees[0].code,
                        description: this.model.summaryInfo.orderFees[0].description,
                        parsedFee: this.model.summaryInfo.orderFees[0].fee,
                        totalFee: this.model.summaryInfo.orderFees[0].totalFee
                    });
                    this.updateTotalFees();
                }
            } if (hasBasketDiscountsApplied) {
                angular.forEach(createOrderData.order.discountsApplied.discounts, (discount) => {
                    if ((!this.CommonsUtilService.isDiscountTypePartnerEquivalent(discount.type)) && (discount.type !== this.PmtConstants.DISCOUNT_TYPES.PARTNER)) {
                        this.NewMainHeaderFacade.updateBasketDiscountsNew(discount, createOrderData.order.discountsApplied.originalPrice, createOrderData.order.discountsApplied.totalDiscount, createOrderData.order.price.total);
                        this.model.paymentInfo.appliedDiscounts.types[discount.type] = discount;
                        this.model.paymentInfo.appliedDiscounts.types[discount.type].originalDiscount = discount.totalDiscount;
                        this.model.paymentInfo.appliedDiscounts.types[discount.type].discount = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.appliedDiscounts.types[discount.type].originalDiscount, true);
                    }
                });
                headerModelData = this.localStorageService.get('headerModel');
                headerModelData.headerModel.shoppingBasket.discountsModel.total = createOrderData.order.discountsApplied.totalDiscount;
                headerModelData.headerModel.shoppingBasket.discountsModel.totalFormated = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, createOrderData.order.discountsApplied.totalDiscount, true);
                headerModelData.headerModel.shoppingBasket.total.totalPrice = this.model.paymentInfo.price.totalPrice;
                //remove ancillaries from total price
                headerModelData.headerModel.shoppingBasket.total.totalPrice -= (previousAncillaries?.total??0);
                headerModelData.headerModel.shoppingBasket.total.formatted = this.model.paymentInfo.price.formattedTotalPrice;
                this.NewMainHeaderFacade.updateHeaderModel(headerModelData);
                if (Object.keys(this.model.paymentInfo.appliedDiscounts.types).length > 0) {
                    for (const type in this.model.paymentInfo.appliedDiscounts.types) {
                        if ((!this.CommonsUtilService.isDiscountTypePartnerEquivalent(this.model.paymentInfo.appliedDiscounts.types[type].type)) && (this.model.paymentInfo.appliedDiscounts.types[type].type !== this.PmtConstants.DISCOUNT_TYPES.PARTNER) && (this.model.paymentInfo.appliedDiscounts.types[type].type !== this.PmtConstants.DISCOUNT_TYPES.VOUCHER)) {
                            discountsAppliedAux[type] = this.model.paymentInfo.appliedDiscounts.types[type];
                        }
                    }
                    this.model.paymentInfo.appliedDiscounts.status = true;
                    this.updateDisccountsTotal(false, discountsAppliedAux);
                }
            }
            if (this.model.paymentInfo.appliedDiscounts && this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER]) {
                if ((this.CommonsUtilService.isDiscountTypePartnerEquivalent(this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER].voucherType)) || (this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER].voucherType === this.PmtConstants.DISCOUNT_TYPES.PARTNER)) {
                    this.NewMainHeaderFacade.updateBasketDiscounts(this.PmtConstants.DISCOUNT_TYPES.PARTNER, this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER]);
                } else {
                    this.NewMainHeaderFacade.updateBasketDiscounts(this.PmtConstants.DISCOUNT_TYPES.VOUCHER, this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER]);
                }

            }
            if (createOrderData?.order) {
                this.DatalayerUtilsService.updateDiscountData(createOrderData.order?.specialDiscounts ?? []);
            }
            this.$timeout(() => {
                if (this.localStorageService.get('selectedFlex') && this.$rootScope.ancOffers) {
                    this.model.paymentInfo.price.formattedTotalPrice = this.localStorageService.get('headerModel').headerModel.shoppingBasket.total.formatted;
                    this.model.paymentInfo.price.totalPrice = this.localStorageService.get('headerModel').headerModel.shoppingBasket.total.original;
                }
                if (this.flowApp === 'CKI') {
                    this.$rootScope.$broadcast('reloadSlider', this.model.paymentInfo);
                }
            });
            if (donationData && this.model.paymentInfo.price.totalPrice !== 0) {
                this.checkDonation('event', true, donationData.option, donationData.donationInfo, donationData.form ? donationData.form.acceptDonationData : null, donationData.form ? donationData.form : null);
            }
            this.model.showOptions.loadingPaymentData = false;
            this.model.showOptions.showLoadingData = false;
            this.PmtModalService.finishWaiting();
            if (this.$rootScope.appMarket === 'BR' || this.$rootScope.appMarket === 'AR') {
                this.localStorageService.set('appliedDisscounts', this.model.paymentInfo.appliedDiscounts.status);
            }
            if (this.localStorageService.get('userLogged')) {
                if ((this.model.paymentInfo.paymentMethods[0].type !== 'IBERIA_PAY' && this.model.paymentInfo.paymentMethods[0].type !== 'ONHOLD_IBERIA_PAY') || (this.model.paymentInfo.customerCreditCards.IBERIA_PAY && this.model.paymentInfo.customerCreditCards.IBERIA_PAY.length > 1) || (this.model.paymentInfo.customerCreditCards.ONHOLD_IBERIA_PAY && this.model.paymentInfo.customerCreditCards.ONHOLD_IBERIA_PAY.length > 1)) {
                    this.model.paymentInfo.iberiaPayLoadingIframe = false;
                }
            }
            if (this.model.paymentInfo.appliedDiscounts) {
                this.updateDisccountsTotal(false, this.model.paymentInfo.appliedDiscounts.types);
            }
            if (this.model.paymentInfo.fullAvios) {
                this.submitPayment();
            }
        }, (error) => {
            this.model.showOptions.loadingPaymentData = false;
            this.PmtModalService.finishWaiting();
        });

        if (this.localStorageService.get('flowApp') === this.PmtConstants.APP_TYPES.CHECKIN)
            this.$rootScope.timeSession.startTime = dayjs();
    };


    /**
     * show regular button if paypal variable is undefined
     * @param {Event} paypalUndefinedEvent Event to lunch function
     */
    paypalUndefined = (event) => {
        this.model.showOptions.showRegularButton = true;
    };

    /**
     * Save paypal token , when user pay with paypal and checkOutService is called
     * @param {Event} payWithPaypal payWithPaypal event to lunch function
     * @param {String} token token to confirm payment in PayPal
     */
    confirmationPaypal = (event, token) => {
        this.localStorageService.set('redirectionPaymentCallback', { status: true, redirectStatus: false, data: this.model, paypalToken: token });
    };
    /**
     * Update param $submitted in paymentForm Object if user click in button paypal
     * @param {Event} submitFormEvent event to launch function
     */
    submitForm = (event) => {
        /* this.paymentsForm.$submitted = true; */
        this.$timeout(() => {
            this.$scope.$apply(() => {
                this.paymentsForm.$submitted = true;
                this.updateSubmittedTabs();
                this.checkFirstFormElementError();
            });
        });
    };
    updateSubmittedTabs = () => {
        this.submittedTabs[this.model.selectedData.selectedTab] = true;
    };
    checkFirstFormElementError = () => {
        let firstInvalid, errorIberiaPay, elementFound = null, headerSize;
        firstInvalid = angular.element('html, body').find('form[name="paymentCtrl.paymentsForm"] input.ng-invalid:visible:first');
        errorIberiaPay = angular.element('html, body').find('#creditCardNumberIbPay');
        elementFound = firstInvalid.length > 0 ? firstInvalid : errorIberiaPay.length > 0 ? errorIberiaPay : null;
        headerSize = angular.element('html, body').find('[ib-sticky]').outerHeight() + 20;
        if (elementFound) {
            angular.element('html, body').animate({
                scrollTop: elementFound.offset().top - headerSize - 20
            });
        }
    };
    /**
     *  Open the modal with all the information
     * @param {Event} event  Event to lunch function
     * @param {String} modalTemplate The html file of the modal
     * @param {Object} model All the necessary information to show the modal
     */
    openModalLinks = (event, modalTemplate, model) => {
        model = model || {};
        angular.extend(model, { idModal: modalTemplate });
        this.PmtModalService.showGenericModal(false, modalTemplate, model).result.then(angular.noop, angular.noop);
    };


    /**
     * Redirection to confirmation page when pay is done
     * @param {Event} paypalPaymentSuccessEvent event to lunch function
     */
    goToConfirmationPage = (event?) => {
        if (this.asComponent) {
            this.$scope.$emit('changeStep', this.PmtConstants.COMPONENT_PAGE.PAYMENTS_PAGE, this.PmtConstants.COMPONENT_PAGE.CONFIRMATION_PAGE);
        } else if (this.flowApp === this.PmtConstants.APP_TYPES.CHECKIN) {
            this.$location.path(this.PmtConstants.PAGES_URL.CKI_BOARDING_CARD_PAGE);
        } else {
            this.$location.path(this.PmtConstants.PAGES_URL.CONFIRMATION_PAGE);
        }
    };

    /**
     * Process the payment with iberia pay.
     * When you receive the iframe event that the tokenization went well, execute the payment function
     * @param {Event} success event to launch the function, this event is sent by the iframe of iberia pay
     */
    iberiaPayTokenizeSucces = (event) => {
        this.localStorageService.set('ibPayTrace', event.detail);
        this.ibPayTrace = event.detail;
        if (this.quotaIbPayCall) {
            delete this.quotaIbPayCall;
            this.numberCallEvent++;
            this.getIberiaPayQuotaOptions();
        } else if (this.numberCallEvent === 0) {
            this.submitPayment(null, false, true);
        }
    };

    /**
     * generate styles to label's iberia pay scripts (cvv and number credit card), calling this.$window.IBDC.setStyles function
     * @param {Event} ready event to launch the function, this event is sent by the iframe of iberia pay when iframes is loaded
     */
    iberiaPayIframeReady = (event) => {
        let iFrameLoadingTime, labelStyle, message = this.$filter('translate')('IBERIA_PAY_ERROR_GENERAL'), modalObject = {
            title: 'IBERIA_PAY_ERROR_GENERAL_TITLE',
            message: message,
            needsTranslate: false,
            showbuttons: {
                accept: {
                    status: true,
                    text: 'IBERIA_PAY_ERROR_GENERAL_BUTTON',
                    accessibleText: 'IBERIA_PAY_ERROR_GENERAL_BUTTON'
                }
            }
        };
        this.$window.IBDC.setStyle('number.label', labelStyle, this.$filter('translate')('CREDIT_CARD_FORM_CARD_NUMBER_LABEL'));
        const CvvLabel = this.$rootScope.appMarket === 'US' ? this.$filter('translate')('CREDIT_CARD_FORM_CVV_NUMBER_LABEL_US') : this.$filter('translate')('CREDIT_CARD_FORM_CVV_NUMBER_LABEL');
        this.$window.IBDC.setStyle('cvv.label', labelStyle, CvvLabel);
        if (!this.model.paymentInfo.iberiaPayLoadingIframe) {
            this.iframeReadyCount++;
            if (this.iframeReadyCount >= 4 && angular.element(this.$document).find('#pmt-generic-error-payment-modal').length === 0) {
                this.PmtModalService.showGenericError(modalObject, true, this.PmtConstants.MODALS.GENERIC_ERROR_MODAL_PAYMENT).result.then(this.reloadPage, this.reloadPage);
            }
        } else {
            this.iframeReadyCount = 0;
        }
        this.$timeout(() => {
            this.model.paymentInfo.iberiaPayLoadingIframe = false;
        });

        const actualDate: any = new Date();
        const initIframeLoading: any = new Date(this.localStorageService.get('initIframeLoading'));
        iFrameLoadingTime= actualDate - initIframeLoading;
        this.QuantumService.sendEvent('376', 0, iFrameLoadingTime/1000);
    };

    reloadPage = () => {
        this.$window.location.reload();
    };

    /**
     * This function added error message to field CREDITCARD_NUMBER or CVV according error code.
     * @param {event} Error Event to launch the function , Is a event send by iFrame IberiaPay if detected any error in  in fields CREDITCARD_NUMBER or CVV
     */
    iberiaPayErrorsControll = (event) => {
        const errorCode = event.detail.resultValidCard;
        this.localStorageService.set('ibPayTrace', event.detail);
        this.ibPayTrace = event.detail;
        if (this.quotaIbPayCall) {
            this.$scope.$broadcast('unCheckQuotas');
            this.model.paymentInfo.iberiaPayLoadingIframe = false;
            delete this.quotaIbPayCall;
        }

        this.$scope.$broadcast('iberiaPayError', errorCode);
        this.$timeout(() => {
            if(this.model.paymentInfo.price.totalPrice !==0)
                this.PmtModalService.finishWaiting();
        });
    };

    /**
     * Remove the information from the avios discount information model, if the user has selected avios and changes to voucher
     * @param {Event} removeAviosDisscounts event to lunch function
     */
    removeAviosDisscounts = (event) => {
        this.model.paymentInfo.appliedDiscounts.status = !!this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER];
        delete this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.AVIOS];
        this.localStorageService.remove('selectedAviosDisccount');
        if (this.model.paymentInfo.price.formattedOldPriceInfo && !this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER]) {
            delete this.model.paymentInfo.price.formattedOldPriceInfo;
        }
        this.model.paymentInfo.price = {
            totalPrice: this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].total,
            formattedTotalPrice: this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.paymentMethods[this.model.selectedData.selectedTab].total, true),
            textTotalPrice: this.$filter('translate')('SUMMARY_TOTAL'),
            showTotalPrice: true
        };

    };
    /**
     *
     * @param {*} event
     * @param {*} info
     * @param {*} index
     */
    changeSelectedHoldOption = (event, info, index) => {
        this.onHoldFreeSelected = index === 0;
        const request = this.localStorageService.get('ibpayCcFeeRequest');
        const priceToShow = this.localStorageService.get('createOrderData') && this.localStorageService.get('createOrderData').order.voucherDiscount ? this.localStorageService.get('createOrderData').order.voucherDiscount.totalBookingAmountWithDiscountApplied : this.model.paymentInfo.onHoldInfo.totalPriceBooking;
        this.localStorageService.set('onHoldOptionSelected', index);
        this.model.selectedData.selectedOnHoldIndex = index;
        if (this.model.paymentInfo.onHoldInfo.onHoldPaymentOptions[index].type !== this.PmtConstants.PAYMENT_TYPES.ONHOLD) {
            this.model.paymentInfo.paymentMethods = [].concat(this.model.paymentInfo.onHoldInfo.onHoldPaymentOptions[index], this.model.paymentInfo.onHoldInfo.otherPaymentMethods);
        } else {
            this.model.paymentInfo.paymentMethods = [this.model.paymentInfo.onHoldInfo.onHoldPaymentOptions[index]];
        }
        this.model.selectedData.selectedTab = 0;
        this.model.summaryInfo.onHoldPayment = `${(info.total>0? '-':'')}${info.totalPriceInfo}`;
        this.model.paymentInfo.onHoldInfo.priceAfterOnHold = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, priceToShow - (info.total ? info.total : info.price.total), true);
        this.model.paymentInfo.onHoldInfo.onHoldPricePerPassenger = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, info.onHoldPricePerPassenger, true);
        this.model.paymentInfo.onHoldInfo.totalOnHoldPrice = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, info.total ? info.total : info.price.total, true);
        this.model.paymentInfo.price = {
            totalPrice: info.total ? info.total : info.price.total,
            formattedTotalPrice: this.CurrencyService.formatPrice(this.model.paymentInfo.currency, info.total ? info.total : info.price.total, true),
            textTotalPrice: this.$filter('translate')('SUMMARY_TOTAL'),
            showTotalPrice: true
        };

        this.NewMainHeaderFacade.updateBasketOthers(info.type, {
            total: info.total ? info.total : info.price.total,
            totalFormatted: info.totalPriceInfo
        });

        function convertCurrencyToMinorUnit (value: string) {
            let [integerPart, fractionalPart = ''] = value.replace(/[^0-9.]/g, '').split('.');
            if (fractionalPart.length === 0) {
                return parseInt(integerPart);
            } else if (fractionalPart.length > 2) {
                return parseInt(integerPart + fractionalPart.substring(0, 3));
            } else {
                return parseInt(integerPart + fractionalPart.padEnd(2, '0'));
            }
        }

        angular.extend(request, {
            paymentPrice: {
                ...request.paymentPrice,
                price: convertCurrencyToMinorUnit(info.totalPriceInfo)
            }
        });
        this.DccService.setDccData();
        this.localStorageService.set('ibpayCcFeeRequest', request);
        this.$scope.$broadcast('updateSelectedTabEvent', this.model.selectedData.selectedTab);
        angular.element(this.$window).triggerHandler('resize');
        this.DccService.setDccData();
    };

    /**
     * Update available paymentMethods through getScripts
     */
    updateAvailablePaymenMethods () {
        const paymentsInfo = {...this.model.paymentInfo};
        paymentsInfo.paymentMethods = this.localStorageService.get('modelPaymentData').paymentInfo.paymentMethods;
        this.model.showOptions.loadingPaymentData = true;
        this.PmtService.getScripts(paymentsInfo, this.model.selectedData.selectedTab).then((response) => {
            this.model.paymentInfo.paymentMethods = response.paymentInfo.paymentMethods;
            this.model.showOptions.loadingPaymentData = false;
            this.PmtModalService.finishWaiting();
        });
    }

    /**
     * Update paymentMethods when user select 'other payment method' in modal PCC option after 449 error code service uri
     * @param {Object} paymentData All information neccesary to update payment methods
     */
    updatePaymentsWithoutCall (paymentData) {
        const transformedPaymentMethods = this.PmtMethodsTransformer.generateModelPayMethods(paymentData.paymentOptions, this.$rootScope.appMarket);
        this.deletePrivateData();
        this.model.paymentInfo.paymentId = transformedPaymentMethods.paymentId;
        this.model.paymentInfo.currency = transformedPaymentMethods.currency;
        this.model.paymentInfo.availableDiscounts = transformedPaymentMethods.availableDiscounts;
        this.model.paymentInfo.somethingToPay = transformedPaymentMethods.somethingToPay;
        this.model.paymentInfo.relatedContent = this.PmtUtilsService.getPaymentRelatedContent(this.model.paymentInfo.relatedContent.original.termsAndConditions, this.model.paymentInfo.relatedContent.original.totalPriceText);
        this.$scope.$broadcast('updateSelectedTabEvent', this.model.selectedData.selectedTab);
        angular.element(this.$window).triggerHandler('resize');
        //this.model.paymentInfo.paymentMethods = transformedPaymentMethods.paymentMethods;
        //this.model.showOptions.loadingPaymentData = false;
        this.updateAvailablePaymenMethods();
    }


    /**
     *  Launch an event to the child component, to disable or enabled the quota option in the BR market,
     * if the user selects a discount or delete disscount with avios.
     * @param {Object} typeDisscount type disscount selected by user
     * @param {Event} disscountAviosSelected to lunch function
     * @param {Boolean}status define if a discount is selected
     */
    disabledQuotasOption = (event, status) => {
        this.$scope.$broadcast('disabledQutasOption', status);

    };
    /**
     * When change something in the basket we generate the payment model with the changes
     */
    checkBasket = (evt) => {
        const flowApp = this.localStorageService.get('flowApp');
        this.CommonsAncillariesService.getAncillarieSummary().then((breakdownInfo) => {
            this.modelSummaryMmbAnc = this.PmtBreakDownUtilsService.transformBreakdownInfo(breakdownInfo);
            if (flowApp === this.PmtConstants.APP_TYPES.BOOKING) {
                this.localStorageService.set('ancillariesPendingBKIFlow', breakdownInfo);
            }
        }, angular.noop);
        this.generateInfoModel(this.localStorageService.get('paymentInfo') && this.localStorageService.get('paymentInfo').issuerCountry || null);
    };

    generateInfoModel (issuerCountry) {

        this.PmtModalService.showWaitingModal('ib-modal-loading-plane-pmt', 'ib-modals ib-modals--transparent', true);
        this.PmtService.getPaymenMethodsInfo(this.dataRequest.ident, issuerCountry, this.$rootScope.serviceURI).then((transformedData) => {
            this.model = transformedData;
            this.model.customerData = this.localStorageService.get('customerData') || null;
            this.model.isLogged = this.localStorageService.get('userLogged');

            this.model.originalPaymentMethods = angular.copy(transformedData.paymentMethods);
            this.model.selectedData.selectedTab = this.getActivateSelectedTab(this.localStorageService.get('selectedPaymentMethod'), this.model.paymentInfo.paymentMethods);
            this.$scope.$broadcast('updateSelectedTabEvent', this.model.selectedData.selectedTab);
            angular.element(this.$window).triggerHandler('resize');
            this.PmtModalService.finishWaiting();
        }, (error) => {
            //reset the total price a 0
            this.model.paymentInfo.price.totalPrice = 0;
            this.model.showOptions.showRegularButton = false;
            this.PmtModalService.finishWaiting();
        });
    }

    /**
     * When change something in the basket we generate the payment model with the changes
     * this function was create to eliminate modal plane view when remove items from basket
     */
    checkBasketCommonHeader = (evt) => {
        this.modelSummaryMmbAnc = this.localStorageService.get('headerModel');
        this.CommonsAncillariesService.getAncillarieSummary().then((breakdownInfo) => {
            this.localStorageService.set('breakdownInfo', breakdownInfo);
            this.generateInfoModelCommonHeader(this.localStorageService.get('paymentInfo') && this.localStorageService.get('paymentInfo').issuerCountry || null);
        }, () => {
            this.generateInfoModelCommonHeader(this.localStorageService.get('paymentInfo') && this.localStorageService.get('paymentInfo').issuerCountry || null);
        });
    };

    generateInfoModelCommonHeader (issuerCountry) {
        const getPaymentMethodsInfo = () => {
            const donationData = this.localStorageService.get('donation');
            this.PmtService.getPaymenMethodsInfo(this.dataRequest.ident, issuerCountry, this.$rootScope.serviceURI).then((transformedData) => {
                this.model = transformedData;
                this.model.customerData = this.localStorageService.get('customerData') || null;
                this.model.isLogged = this.localStorageService.get('userLogged');
                this.model.originalPaymentMethods = angular.copy(transformedData.paymentMethods);
                this.model.selectedData.selectedTab = this.getActivateSelectedTab(this.localStorageService.get('selectedPaymentMethod'), this.model.paymentInfo.paymentMethods);
                this.$scope.$broadcast('updateSelectedTabEvent', this.model.selectedData.selectedTab);
                angular.element(this.$window).triggerHandler('resize');
                if (this.localStorageService.get('userLogged')) {
                    if ((this.model.paymentInfo.paymentMethods[0].type !== 'IBERIA_PAY' && this.model.paymentInfo.paymentMethods[0].type !== 'ONHOLD_IBERIA_PAY') || (this.model.paymentInfo.customerCreditCards.IBERIA_PAY && this.model.paymentInfo.customerCreditCards.IBERIA_PAY.length > 1) || (this.model.paymentInfo.customerCreditCards.ONHOLD_IBERIA_PAY && this.model.paymentInfo.customerCreditCards.ONHOLD_IBERIA_PAY.length > 1)) {
                        this.model.paymentInfo.iberiaPayLoadingIframe = false;
                    }
                }
                if (donationData) {
                    this.checkDonation('event', true, donationData.option, donationData.donationInfo, donationData.form ? donationData.form.acceptDonationData : null, donationData.form ? donationData.form : null);
                }
                this.$scope.$broadcast('hideLoadingCard');
                this.$rootScope.$broadcast('closeModalWaitMenu');
            }, (error) => {
                this.model.paymentInfo.price.totalPrice = 0;
                this.model.showOptions.showRegularButton = false;
                this.$scope.$broadcast('hideLoadingCard');
                this.$rootScope.$broadcast('closeModalWaitMenu');
                this.localStorageService.set('nextStepAllowed', false);
            });
        };
        this.model.paymentInfo.iberiaPayLoadingIframe = true;
        if (this.model.paymentInfo.appliedDiscounts.status && this.model.paymentInfo.appliedDiscounts.types.VOUCHER) {
            this.PmtAssFassAncillariesService.deleteVoucher(this.model.paymentInfo.appliedDiscounts.types.VOUCHER.id).then((response) => {
                response.pendingPaymentItems.length > 0 ? this.PmtAssFassAncillariesService.getVoucherValidation(this.model.paymentInfo.appliedDiscounts.types.VOUCHER.id, { email: null }).then(getPaymentMethodsInfo, angular.noop) : getPaymentMethodsInfo();
            }, angular.noop);
        } else {
            getPaymentMethodsInfo();
        }
    }


    /**
     * Update layer information  when payment finish
     */
    updateDatalayerInformationCkiFlow () {

        const confirmationDatalayerInfo = this.localStorageService.get('confirmationDatalayerInfo') || {};
        if (this.model.paymentInfo.selectedCard) {
            confirmationDatalayerInfo[this.PmtDatalayerConstants.DATALAYER_INFO.CREDITCARD_TYPE] = this.model.paymentInfo.selectedCard.cardTypeCode;
        }
        confirmationDatalayerInfo[this.PmtDatalayerConstants.DATALAYER_INFO.CURRENCY] = this.model.currencyCode;
        this.localStorageService.set('confirmationDatalayerInfo', confirmationDatalayerInfo);

        const datalayerEcommerceInfo = this.DatalayerEcommerceUtilsService.updateDatalayerCkiInfoPayments(this.model);
        this.localStorageService.set('confirmationEcommerceInfo', datalayerEcommerceInfo);
    }
    /**
     * This method update payment methods, summary an total price info when user interactue with donation component
     *
     * @param {*} event
     * @param {*} status donation check is select
     * @param {*} option object with donation option selected
     * @param {*} donationInfo donation info from service
     * @param {*} newsletter old control for form check
     * @param {*} donationForm object with form information, (newslatter check and option selected)
     */
    checkDonation = (event, status, option, donationInfo, newsletter, donationForm) => {
        let orderFeesIndex = 0, foundedDonation = false, foundedDonationIndex, paymentMethodIndex, datalayer_general = this.DataLayerService.getDatalayerGeneral(),
            lastDonation, oldFee = this.localStorageService.get('creditCardFee') ? this.localStorageService.get('creditCardFee').totalFee : null, headerModelData: any = {}, createOrderData: any = {}, hasBasketDiscountsApplied = false;
        lastDonation = this.localStorageService.get('donation') && this.localStorageService.get('donation').option && this.localStorageService.get('donation').option.option ? this.localStorageService.get('donation').option : 0;
        createOrderData = this.localStorageService.get('createOrderData');
        this.donationEnabled = status;
        if (createOrderData && createOrderData.order && createOrderData.order.discountsApplied && createOrderData.order.discountsApplied.discounts && createOrderData.order.discountsApplied.discounts.length > 0) {
            hasBasketDiscountsApplied = true;
        }
        while (!foundedDonation && orderFeesIndex < this.model.summaryInfo.orderFees.length) {
            if (this.model.summaryInfo.orderFees[orderFeesIndex].code === 'donation') {
                foundedDonationIndex = orderFeesIndex;
                foundedDonation = true;
            }
            orderFeesIndex++;
        }
        if (status) {
            this.localStorageService.set('donation', { option: option, partner: donationInfo.partner, newsletter: newsletter, donationInfo: donationInfo, form: donationForm });
            if (!foundedDonation) {
                this.model.summaryInfo.orderFees.push({
                    code: 'donation',
                    description: donationInfo.partner,
                    fee: option.formatedPrice,
                    totalFee: option.option
                });
                this.NewMainHeaderFacade.updateBasketOthers('DONATION', {
                    code: 'donation',
                    description: donationInfo.partner,
                    total: option.option,
                    totalFormatted: option.formatedPrice
                });
            } else {
                datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE] = Math.round((datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE] - lastDonation.option) * 100) / 100;
                datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE_WITHOUT_FEE] = Math.round((datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE_WITHOUT_FEE] - lastDonation.option) * 100) / 100;
                this.model.summaryInfo.orderFees[foundedDonationIndex].fee = option.formatedPrice;
                this.model.summaryInfo.orderFees[foundedDonationIndex].totalFee = option.option;
                this.NewMainHeaderFacade.updateBasketOthers('DONATION', {
                    code: 'donation',
                    description: donationInfo.partner,
                    total: option.option,
                    totalFormatted: option.formatedPrice
                });
            }
            datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE] = Math.round((datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE] + option.option) * 100) / 100;
            datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE_WITHOUT_FEE] = Math.round((datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE_WITHOUT_FEE] + option.option) * 100) / 100;

        } else if (foundedDonation) {
            if (!status) {
                datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE] = Math.round((datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE] - lastDonation.option) * 100) / 100;
                datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE_WITHOUT_FEE] = Math.round((datalayer_general[this.PmtDatalayerConstants.DATALAYER_INFO.TOTAL_PRICE_WITHOUT_FEE] - lastDonation.option) * 100) / 100;
            }
            this.localStorageService.remove('donation');
            this.NewMainHeaderFacade.updateBasketOthers('DONATION');
            this.model.summaryInfo.orderFees.splice(foundedDonationIndex, 1);
        }

        for (paymentMethodIndex = 0; paymentMethodIndex < this.model.paymentInfo.paymentMethods.length; paymentMethodIndex++) {
            if ((!this.model.paymentInfo.paymentMethods[paymentMethodIndex].selectedDonation || (this.model.paymentInfo.paymentMethods[paymentMethodIndex].selectedDonation &&
                option.option !== this.model.paymentInfo.paymentMethods[paymentMethodIndex].selectedDonation.option.option) || !status) &&
                this.PmtUtilsService.checkAvailableDonation(donationInfo.possibilities, this.model.paymentInfo.paymentMethods[paymentMethodIndex])) {
                if (this.model.paymentInfo.appliedDiscounts && (this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.AVIOS])) {
                    this.model.paymentInfo.paymentMethods[paymentMethodIndex].selectedDonation = { option: option, partner: donationInfo.partner, newsletter: newsletter, donationInfo: donationInfo, form: donationForm };
                    this.model.paymentInfo.paymentMethods[paymentMethodIndex].total = status ? (this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total
                        - parseFloat(this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.AVIOS].originalDiscount))
                        + option.option : this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total - parseFloat(this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.AVIOS].originalDiscount);
                    this.model.paymentInfo.paymentMethods[paymentMethodIndex].totalPriceInfo = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.paymentMethods[paymentMethodIndex].total, true);
                    if (this.model.paymentInfo.price) {
                        this.model.paymentInfo.price.totalPrice = this.model.paymentInfo.paymentMethods[paymentMethodIndex].total + (oldFee ? oldFee : 0);
                        this.model.paymentInfo.price.formattedTotalPrice = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.price.totalPrice, true);
                        this.model.paymentInfo.price.formattedOldPriceInfo = status ? this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total + option.option + (this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER] ? this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER].originalDiscount : 0), true)
                            : this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER] ? this.model.paymentInfo.paymentMethods[paymentMethodIndex].oldPriceInfo
                                : this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total, true);
                    } else {
                        this.model.paymentInfo.price = {
                            totalPrice: this.model.paymentInfo.paymentMethods[paymentMethodIndex].total + (oldFee ? oldFee : 0),
                            formattedTotalPrice: this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.price.totalPrice, true),
                            formattedOldPriceInfo: status ? this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total + option.option + (this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER] ? this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER].originalDiscount : 0), true)
                                : this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER] ? this.model.paymentInfo.paymentMethods[paymentMethodIndex].oldPriceInfo
                                    : this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total, true),
                            textTotalPrice: this.$filter('translate')('SUMMARY_TOTAL'),
                            showTotalPrice: true
                        };
                    }
                } else {
                    this.model.paymentInfo.paymentMethods[paymentMethodIndex].selectedDonation = { option: option, partner: donationInfo.partner, newsletter: newsletter, donationInfo: donationInfo, form: donationForm };
                    if (status && this.model.paymentInfo.selectedPaymentInfo.selectedCard && this.model.paymentInfo.selectedPaymentInfo.selectedCard.totalFee > 0) {
                        this.model.paymentInfo.paymentMethods[paymentMethodIndex].total = this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total + option.option + this.model.paymentInfo.selectedPaymentInfo.selectedCard.totalFee;
                    } else if (status) {
                        this.model.paymentInfo.paymentMethods[paymentMethodIndex].total = this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total + option.option;
                    } else {
                        this.model.paymentInfo.paymentMethods[paymentMethodIndex].total = this.model.paymentInfo.selectedPaymentInfo.selectedCard && this.model.paymentInfo.selectedPaymentInfo.selectedCard.totalFee > 0 ? this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total + this.model.paymentInfo.selectedPaymentInfo.selectedCard.totalFee : this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total;
                    }
                    this.model.paymentInfo.paymentMethods[paymentMethodIndex].totalPriceInfo = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.paymentMethods[paymentMethodIndex].total, true);
                    if (this.model.paymentInfo.price) {
                        this.model.paymentInfo.price.totalPrice = this.model.paymentInfo.paymentMethods[paymentMethodIndex].total + (oldFee ? oldFee : 0);
                        this.model.paymentInfo.price.formattedTotalPrice = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.price.totalPrice, true);
                    } else {
                        this.model.paymentInfo.price.totalPrice = {
                            totalPrice: this.model.paymentInfo.paymentMethods[paymentMethodIndex].total + (oldFee ? oldFee : 0),
                            formattedTotalPrice: this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.price.totalPrice, true),
                            textTotalPrice: this.$filter('translate')('SUMMARY_TOTAL'),
                            showTotalPrice: true
                        };
                    }
                    if (this.model.paymentInfo.appliedDiscounts && (this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER])) {
                        this.model.paymentInfo.price.formattedOldPriceInfo = status ? this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total + option.option + (this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER] ? this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER].originalDiscount : 0), true)
                            : this.model.paymentInfo.appliedDiscounts.types[this.PmtConstants.DISCOUNT_TYPES.VOUCHER] ? this.model.paymentInfo.paymentMethods[paymentMethodIndex].oldPriceInfo
                                : this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.paymentInfo.originalPaymentMethods[paymentMethodIndex].total, true);
                    }
                }
                headerModelData = this.localStorageService.get('headerModel');
                if (hasBasketDiscountsApplied && headerModelData) {
                    headerModelData.headerModel.shoppingBasket.total.totalPrice = this.model.paymentInfo.price.totalPrice;
                    headerModelData.headerModel.shoppingBasket.total.formatted = this.model.paymentInfo.price.formattedTotalPrice;
                    this.NewMainHeaderFacade.updateHeaderModel(headerModelData);
                }
            }
            if (!status) {
                this.model.paymentInfo.paymentMethods[paymentMethodIndex].selectedDonation = null;
            }
            this.updateTotalFees();
        }
    };
    /**
     * This functions is executed after pmt error when user dont have nothing for pay and generate model to show pmt-view.
     * In this case if we want show pmt-view is neccesary remove the linea code 'this.submitPayment()', because this produce that flow continue
     * and dont stop in ptm view.
     * */
    noPayment = (event, paymentData) => {
        let flowApp = this.localStorageService.get('flowApp'), donationData = this.localStorageService.get('donation'), currency, fareData = this.localStorageService.get('fareData'), bookingInfo = this.localStorageService.get('bookingInfo'),
            flowId = bookingInfo.flowId ? bookingInfo.flowId : this.localStorageService.get('flowId');
        if (flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE || flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED) {
            this.PmtModalService.finishWaiting();
            this.PmtModalService.showWaitingModal('ib-modal-pmt-cards', 'ib-modals ib-modals--transparent', true);
            this.updateDatalayerWithQuadrigam(this.localStorageService.get('pmtModelInfo').quadrigams.payments, null, this.PmtUtilsService.isUserLogged());
            /* INIT DELETE GA4 MIGRATION */
            this.DatalayerUtilsService.sendDatalayerEvent(this.PmtDatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
            /* FINISH DELETE GA4 MIGRATION */
            this.DigitalDataService.emitViewEvent();
            //this.DatalayerUtilsService.updateDatalayerEvent(this.PmtDatalayerConstants.DATALAYER_EVENT_TYPES.VIEW, '', '', '');
            this.MonetateUtilsService.updateMonetateWithQuadrigam(this.PmtConstants.MONETATE_INFO.SETPAGETYPE, this.localStorageService.get('pmtModelInfo').quadrigams.payments);
            this.$timeout(() => {
                this.$rootScope.$broadcast('sendUpdateToMonetate');
            });
            currency = this.CurrencyService.getCurrencyObject(fareData ? fareData.contextMetadata.currencies[0] : this.localStorageService.get('bookingInfo').contextMetadata.currencies);
            this.PmtService.getConditionService(flowId, this.$rootScope.serviceURI).then((conditionsData) => {
                this.model = this.PmtTransformer.noPaymentModel(currency, paymentData, conditionsData);
                this.model.summaryInfo.passengers.noPaymentSummary = true;
                this.model.noPaymentSummary = true;
                this.localStorageService.set('noPaymentSummary', true);
                if (donationData) {
                    this.checkDonation('event', true, donationData.option, donationData.donationInfo, donationData.form ? donationData.form.acceptDonationData : null, donationData.form ? donationData.form : null);
                }
                this.$timeout(() => {
                    if (this.localStorageService.get('selectedFlex') && this.$rootScope.ancOffers) {
                        this.model.paymentInfo.price.formattedTotalPrice = this.localStorageService.get('headerModel').headerModel.shoppingBasket.total.formatted;
                        this.model.paymentInfo.price.totalPrice = this.localStorageService.get('headerModel').headerModel.shoppingBasket.total.original;
                    }
                });
                this.localStorageService.set('modelPaymentData', this.model);
                this.localStorageService.set('noPaymentVCFlow', true);
                this.submitPayment();
            }, () => {
                const conditionsData = {
                    data: {
                        error: 'unauthorized',
                        error_description: 'Invalid token'
                    },
                    errorCode: 403
                };
                this.model = this.PmtTransformer.noPaymentModel(currency, paymentData, conditionsData);
                this.model.summaryInfo.passengers.noPaymentSummary = true;
                this.model.noPaymentSummary = true;
                this.localStorageService.set('noPaymentSummary', true);
                if (donationData) {
                    this.checkDonation('event', true, donationData.option, donationData.donationInfo, donationData.form ? donationData.form.acceptDonationData : null, donationData.form ? donationData.form : null);
                }
                this.PmtModalService.finishWaiting();
                this.$timeout(() => {
                    if (this.localStorageService.get('selectedFlex') && this.$rootScope.ancOffers) {
                        this.model.paymentInfo.price.formattedTotalPrice = this.localStorageService.get('headerModel').headerModel.shoppingBasket.total.formatted;
                        this.model.paymentInfo.price.totalPrice = this.localStorageService.get('headerModel').headerModel.shoppingBasket.total.original;
                    }
                });
                this.localStorageService.set('modelPaymentData', this.model);
                this.PmtModalService.showWaitingModal('ib-modal-pmt-cards', 'ib-modals ib-modals--transparent', true);
                this.submitPayment();
            });
        }
    };

    /**
     * This functions is launched when in the function this.submitPayment() detected that user dont have nothing for pay.
     * This will execute the call to orderChange for flow CV.
     *  */
    noPaymentConfirm () {
        this.PmtService.noPaymentConfirm(this.$rootScope.serviceURI).then((response) => {
            this.numberCallEvent = 0;
            this.localStorageService.set('fullIssuedPaiment', response);
            this.PmtModalService.finishWaiting();
            if (this.asComponent) {
                this.$scope.$emit('changeStep', this.PmtConstants.COMPONENT_PAGE.PAYMENTS_PAGE, this.PmtConstants.COMPONENT_PAGE.CONFIRMATION_PAGE);
            } else {
                this.$location.path(this.PmtConstants.PAGES_URL.CONFIRMATION_PAGE);
            }
            this.localStorageService.remove('updateSeatLocal');
        }, () => {
            this.numberCallEvent = 0;
            this.PmtModalService.finishWaiting();
        });
    }

    /* This functions redirect to Home when user pay correctly and return to payment page */
    goToHome () {
        if (this.localStorageService.get('flowApp') !== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_BIDS) {
            this.localStorageService.remove('paySucces');
            this.$window.location.href = this.$window.location.origin;
        }
    }
    updateTotalFees () {
        if (this.model && this.model.summaryInfo.orderFees) {
            this.model.summaryInfo.orderFees.total = 0;
            angular.forEach(this.model.summaryInfo.orderFees, (orderFee) => {
                this.model.summaryInfo.orderFees.total += orderFee.totalFee;
            });
            if(this.model.summaryInfo.orderFees.total ===0) {
                this.model.summaryInfo.orderFees = [];
            }
            this.model.summaryInfo.orderFees.totalFormatted = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, this.model.summaryInfo.orderFees.total, true).trim();
        }
    }
    updateDisccountsTotal = (event, appliedDiscountTypes) => {
        let headerModelData: any = {};
        headerModelData = this.localStorageService.get('headerModel');
        this.model.paymentInfo.appliedDiscounts.discountsTotal = 0;
        angular.forEach(appliedDiscountTypes, (discount) => {
            this.model.paymentInfo.appliedDiscounts.discountsTotal += discount.originalDiscount;
        });
        headerModelData.headerModel.shoppingBasket.discountsModel.total = this.model.paymentInfo.appliedDiscounts.discountsTotal;
        headerModelData.headerModel.shoppingBasket.discountsModel.totalFormated = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, -this.model.paymentInfo.appliedDiscounts.discountsTotal, true);
        this.NewMainHeaderFacade.updateHeaderModel(headerModelData);
        this.model.paymentInfo.appliedDiscounts.discountsTotalFormatted = this.CurrencyService.formatPrice(this.model.paymentInfo.currency, -this.model.paymentInfo.appliedDiscounts.discountsTotal, true).trim();
        this.updateTotalFees();
        this.updateAvailablePaymenMethods();
        this.$rootScope.$broadcast('loadingVoucherBasket', false);
    };
    selectQuadrigam () {

        let quadrigam;

        if (this.localStorageService.get('multiCitySearch')) {
            if (this.localStorageService.get('isHMAD')) {
                quadrigam = this.PmtConstants.QUADRIGAMS.HMAD_PASSENGERS_INFO;
            } else {
                quadrigam = this.PmtConstants.QUADRIGAMS.MULTI_PASSENGERS_INFO;
            }
        } else if (this.$rootScope.isRedemptionFlow) {
            if (this.$rootScope.isPointsOBFlow) {
                quadrigam = this.PmtConstants.QUADRIGAMS.PA_PASSENGERS_ONB_REDENTION;
            } else {
                quadrigam = this.PmtConstants.QUADRIGAMS.PA_PASSENGERS_REDENTION;
            }
        } else {
            switch (this.localStorageService.get('flowApp')) {
                    case 'PAOB':
                        quadrigam = this.PmtConstants.QUADRIGAMS.PA_PASSENGERS;
                        break;
                    case 'PAOBONB':
                        quadrigam = this.PmtConstants.QUADRIGAMS.PA_PASSENGERS_ONB;
                        break;
                    case 'PARE':
                        quadrigam = this.PmtConstants.QUADRIGAMS.PA_PASSENGERS_REDENTION;
                        break;
                    case 'PAREONB':
                        quadrigam = this.PmtConstants.QUADRIGAMS.PA_PASSENGERS_ONB_REDENTION;
                        break;
                    case 'BBKI':
                        quadrigam = this.PmtConstants.QUADRIGAMS.BKI_PAYMENT;
                        break;
                    default:
                        break;
            }
        }
        return quadrigam;
    }


    openOnholdLightBox = (event)  => {
        this.modelLightBox = {
            title: 'ONHOLD_OPTION_TITLE',
            subtitle: this.CommonsUtilService.fiterTextOptionOnhold().modalText,
            text: 'ONHOLD_OPTION_TEXT_ANC'
        };
        if (this.CommonsUtilService.isAvailableLightBox()) {
            this.localStorageService.set('OnholdLightBoxShowed', true);
            this.showOnHoldNotice = true;
        }
    };
    closeOnholdLightBox = (event, show) => {
        this.showOnHoldNotice = show;
    };

    /**
     * Select a page title according to the defined flow.
     */
    setTitlePage () {
        const quadrigam = this.localStorageService.get('pmtModelInfo')?.quadrigams.payments;
        switch (this.flowApp) {
                case this.PmtConstants.TITLES_APP.ONHOLD:
                    this.CommonsUtilService.setTitlePage('BKI_TITLE_PAGE_PAYMENT_PAGE_ONHOLD');
                    break;
                case this.PmtConstants.TITLES_APP.MANAGEMYBOOKING_BIDS:
                    this.CommonsUtilService.setTitlePage('MMB_TITLE_PAGE_BID_PAYMENT');
                    break;
                case this.PmtConstants.TITLES_APP.MANAGEMYBOOKING_ANCILLARIES:
                    if(quadrigam == 'STPURCJBR') {
                        this.CommonsUtilService.setTitlePage('MMB_TITLE_DEEPLINK_SEAT_PAYMENT');
                    } else if(quadrigam == 'MOPURC') {
                        this.CommonsUtilService.setTitlePage('MMB_TITLE_PAGE_BID_PAYMENT');
                    } else {
                        this.CommonsUtilService.setTitlePage('MMB_TITLE_PAGE_ANC_PAYMENT');
                    }
                    break;
                case this.PmtConstants.TITLES_APP.MANAGEMYBOOKING_VOLUNTARY_CHANGE:
                    this.CommonsUtilService.setTitlePage('MMB_VOLUNTARY_CHANGE_PAYMENT');
                    break;
                case this.PmtConstants.TITLES_APP.MANAGEMYBOOKING_ONHOLD:
                    if(quadrigam == 'OHINFO') {
                        this.CommonsUtilService.setTitlePage('MMB_TITLE_ON_HOLD_CONF_PAYMENT');
                    } else if(quadrigam == 'RTBKCF') {
                        this.CommonsUtilService.setTitlePage('MMB_TITLE_ON_HOLD_CONF_CONFIRMATION');
                    }
                    break;
                case this.PmtConstants.TITLES_APP.CHECKIN:
                    this.CommonsUtilService.setTitlePage('CKI_TITLE_PAGE_ANC_PAYMENT');
                    break;
                case this.PmtConstants.TITLES_APP.GIFTCARDS:
                    this.CommonsUtilService.setTitlePage('GIFT_CARD_CONFIGURATION_REPURC_TITLE');
                    break;
                case this.PmtConstants.TITLES_APP.MANAGEMYBOOKING_ONHOLD:
                    this.CommonsUtilService.setTitlePage('MMB_TITLE_ON_HOLD_CONF_PAYMENT');
                    break;
                case this.PmtConstants.TITLES_APP.BOOKING:
                    if(this.isShuttleFlow){
                        this.CommonsUtilService.setTitlePage('BKI_SHUTTLE_PAYMENT_PAGE');
                    } else this.CommonsUtilService.setTitlePage('GENERAL_TITLE_PAYMENT_PAGE');
                    break;
                default:
                    this.CommonsUtilService.setTitlePage('GENERAL_TITLE_PAYMENT_PAGE');
        }
    }

    updateDatalayerWithQuadrigam (quadrigam, extendedObject, isUserLogged) {
        const isFlowDuplicated = this.localStorageService.get('isFlowDuplicated');
        const extendObj = extendedObject || {};
        const extendDigitalData = this.localStorageService.get('confirmationDigitalInfo') || {};

        if (quadrigam === this.PmtConstants.QUADRIGAMS.CKI_PAYMENT && this.flowApp === this.PmtConstants.APP_TYPES.CHECKIN) {
            /* INIT DELETE GA4 MIGRATION */
            extendObj[this.DatalayerConstants.DATALAYER_INFO.STEP] = this.DatalayerConstants.DATALAYER_FLOW_CKI.IBCKIPURC;
            extendObj[this.DatalayerConstants.DATALAYER_INFO.PROCESS] = isFlowDuplicated ? this.DatalayerConstants.DATALAYER_FLOW_CKI.PROCESS_DUPLICATE : this.DatalayerConstants.DATALAYER_FLOW_CKI.PROCESS;
            /* FINISH DELETE GA4 MIGRATION */
            extendDigitalData[this.DatalayerGeneralConstants.STEP] = this.DatalayerConstants.DATALAYER_FLOW_CKI.IBCKIPURC;
            extendDigitalData[this.DatalayerGeneralConstants.PROCESS] = isFlowDuplicated ? this.DatalayerConstants.DATALAYER_FLOW_CKI.PROCESS_DUPLICATE : this.DatalayerConstants.DATALAYER_FLOW_CKI.PROCESS;
        }

        if (this.flowApp === this.PmtConstants.APP_TYPES.BOOKING ||  this.flowApp === this.PmtConstants.APP_TYPES.ONHOLD) {
            /* INIT DELETE GA4 MIGRATION */
            extendObj[this.DatalayerConstants.DATALAYER_INFO.PROCESS] = this.CommonsUtilService.getProcess();
            extendObj[this.DatalayerConstants.DATALAYER_INFO.STEP] = this.DatalayerUtilsService.getStepFromQuadrigam(quadrigam, this.DatalayerConstants.DATALAYER_VIEWS.PAYMENTS);
            /* FINISH DELETE GA4 MIGRATION */
            extendDigitalData[this.DatalayerGeneralConstants.PROCESS] = this.CommonsUtilService.getProcess();
            extendDigitalData[this.DatalayerGeneralConstants.STEP] = this.DatalayerUtilsService.getStepFromQuadrigam(quadrigam, this.DatalayerConstants.DATALAYER_VIEWS.PAYMENTS);
        }

        if (quadrigam === this.PmtConstants.QUADRIGAMS.ON_HOLD_CONF_PAYMENT && this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ONHOLD) {
            /* INIT DELETE GA4 MIGRATION */
            extendObj[this.DatalayerConstants.DATALAYER_INFO.PROCESS] = this.DatalayerConstants.DATALAYER_VIEWS.ONHOLD_CONFIRMATION;
            extendObj[this.DatalayerConstants.DATALAYER_INFO.STEP] = this.PmtDatalayerConstants.DATALAYER_VALUES.PAYMENT;
            /* FINISH DELETE GA4 MIGRATION */
            extendDigitalData[this.DatalayerGeneralConstants.PROCESS] = this.DatalayerConstants.DATALAYER_VIEWS.ONHOLD_CONFIRMATION;
            extendDigitalData[this.DatalayerGeneralConstants.STEP] = this.PmtDatalayerConstants.DATALAYER_VALUES.PAYMENT;
        }

        if (quadrigam === this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_PAYMENT && this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ANCILLARIES) {
            /* INIT DELETE GA4 MIGRATION */
            extendObj[this.DatalayerConstants.DATALAYER_INFO.PROCESS] = this.DatalayerConstants.DATALAYER_VIEWS.ANCILLARIES;
            /* FINISH DELETE GA4 MIGRATION */
            extendDigitalData[this.DatalayerGeneralConstants.PROCESS] = this.DatalayerConstants.DATALAYER_VIEWS.ANCILLARIES;
        }

        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, extendObj, isUserLogged);
        /* FINISH DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, extendDigitalData, isUserLogged);
    }

    updateBasketOnHold (onHoldInfo, appliedDiscountTypes) {
        let headerModelData: any = {};
        headerModelData = this.localStorageService.get('headerModel');
        if (headerModelData?.headerModel?.shoppingBasket?.total && onHoldInfo) {
            headerModelData.headerModel.shoppingBasket.discountsModel.discounts= appliedDiscountTypes||{};
            headerModelData.headerModel.shoppingBasket.discountsModel.hasDiscounts = Object.keys(appliedDiscountTypes).length > 0;
            headerModelData.headerModel.shoppingBasket.total = {
                formatted : onHoldInfo.priceAfterOnHold,
                original: onHoldInfo.totalPriceBooking,
                total: onHoldInfo.totalPriceBooking
            };
            this.NewMainHeaderFacade.updateHeaderModel(headerModelData);
            if (appliedDiscountTypes) {
                this.updateDisccountsTotal(false, appliedDiscountTypes);
            }
        }
    }


    loadNemuruComponent = (event, formData) => {
        this.ibPmtNemuruService.setNemuruAvailable(true);
        this.model.paymentInfo.Nemuru={
            accessToken:formData.component.accessToken,
            orderId:formData.component.orderId
        };
    };

    loadMercadoPagoComponent = (event, formData) => {
        this.ibPmtMercadoPagoService.setMercadoPagoAvailable(true);
        this.model.paymentInfo.MERCADO_PAGO = {
            preferenceId :formData.component.id
        };
        this.localStorageService.set('redirectionPaymentCallback', { status: true, redirectStatus: false, data: this.model });
    };

    updateCalcAvios = (evt, flightAviosInfo) => {
        this.IbUiAviosSummaryService.getCalculateAviosSummary(flightAviosInfo).then(
            (response) => this.updateAviosCalculated(),
            (error) => this.aviosCalculatedError()
        );
    };

    callWithKeepSessionAlive (paymentMethod) {
        return (...args) => {
            this.CommonsKeepAliveUtilsService.keepSessionAlive();
            return paymentMethod.apply(this, args);
        };
    }

    $onInit = this.activate();
}
